var map = {
	"./CurrencyManagement": 1043,
	"./CurrencyManagement.js": 1043,
	"./TRM": 1044,
	"./TRM.js": 1044,
	"./TRM/filter": 173,
	"./TRM/filter.js": 173,
	"./TRM/table": 174,
	"./TRM/table.js": 174,
	"./accounting/accounts": 1045,
	"./accounting/accounts.js": 1045,
	"./accounting/accounts/filter": 175,
	"./accounting/accounts/filter.js": 175,
	"./accounting/accounts/table": 176,
	"./accounting/accounts/table.js": 176,
	"./accounting/area": 1046,
	"./accounting/area.js": 1046,
	"./accounting/area/filter": 999,
	"./accounting/area/filter.js": 999,
	"./accounting/area/table": 177,
	"./accounting/area/table.js": 177,
	"./accounting/area_copy": 1047,
	"./accounting/area_copy.js": 1047,
	"./accounting/closingDayReport": 1048,
	"./accounting/closingDayReport.js": 1048,
	"./accounting/closingDayReport/filter": 178,
	"./accounting/closingDayReport/filter.js": 178,
	"./accounting/closingDayReport/table": 179,
	"./accounting/closingDayReport/table.js": 179,
	"./accounting/concepts": 1049,
	"./accounting/concepts.js": 1049,
	"./accounting/concepts/filter": 180,
	"./accounting/concepts/filter.js": 180,
	"./accounting/concepts/table": 181,
	"./accounting/concepts/table.js": 181,
	"./accounting/costCenter": 1050,
	"./accounting/costCenter.js": 1050,
	"./accounting/costCenter/filter": 182,
	"./accounting/costCenter/filter.js": 182,
	"./accounting/costCenter/table": 183,
	"./accounting/costCenter/table.js": 183,
	"./accounting/employees": 1051,
	"./accounting/employees.js": 1051,
	"./accounting/employees/filter": 1000,
	"./accounting/employees/filter.js": 1000,
	"./accounting/employees/table": 184,
	"./accounting/employees/table.js": 184,
	"./accounting/expenses": 1052,
	"./accounting/expenses.js": 1052,
	"./accounting/expenses/filter": 185,
	"./accounting/expenses/filter.js": 185,
	"./accounting/expenses/table": 186,
	"./accounting/expenses/table.js": 186,
	"./accounting/incomes": 1053,
	"./accounting/incomes.js": 1053,
	"./accounting/incomes/filter": 187,
	"./accounting/incomes/filter.js": 187,
	"./accounting/incomes/table": 188,
	"./accounting/incomes/table.js": 188,
	"./accounting/position": 1054,
	"./accounting/position.js": 1054,
	"./accounting/position/filter": 1001,
	"./accounting/position/filter.js": 1001,
	"./accounting/position/table": 189,
	"./accounting/position/table.js": 189,
	"./accounting/productsThirdBetShop": 1055,
	"./accounting/productsThirdBetShop.js": 1055,
	"./accounting/productsThirdBetShop/filter": 1002,
	"./accounting/productsThirdBetShop/filter.js": 1002,
	"./accounting/productsThirdBetShop/table": 190,
	"./accounting/productsThirdBetShop/table.js": 190,
	"./accounting/productsThirdByBetShop": 1056,
	"./accounting/productsThirdByBetShop.js": 1056,
	"./accounting/productsThirdByBetShop/filter": 191,
	"./accounting/productsThirdByBetShop/filter.js": 191,
	"./accounting/productsThirdByBetShop/table": 192,
	"./accounting/productsThirdByBetShop/table.js": 192,
	"./accounting/productsThirdQuota": 1057,
	"./accounting/productsThirdQuota.js": 1057,
	"./accounting/productsThirdQuota/filter": 193,
	"./accounting/productsThirdQuota/filter.js": 193,
	"./accounting/productsThirdQuota/table": 194,
	"./accounting/productsThirdQuota/table.js": 194,
	"./accounting/providers": 1058,
	"./accounting/providers.js": 1058,
	"./accounting/providers/filter": 1003,
	"./accounting/providers/filter.js": 1003,
	"./accounting/providers/table": 195,
	"./accounting/providers/table.js": 195,
	"./accounting/providers/tableProductsThirdBetShop": 1059,
	"./accounting/providers/tableProductsThirdBetShop.js": 1059,
	"./accounting/providers_copy": 1060,
	"./accounting/providers_copy.js": 1060,
	"./accounting/squareDayReport": 1061,
	"./accounting/squareDayReport.js": 1061,
	"./accounting/squareDayReport/filter": 196,
	"./accounting/squareDayReport/filter.js": 196,
	"./accounting/squareDayReport/table": 197,
	"./accounting/squareDayReport/table.js": 197,
	"./accounting/squareDayReport2": 1062,
	"./accounting/squareDayReport2.js": 1062,
	"./accounting/squareDayReport2/filter": 198,
	"./accounting/squareDayReport2/filter.js": 198,
	"./accounting/squareDayReport2/table": 199,
	"./accounting/squareDayReport2/table.js": 199,
	"./accounting/typeCenterPosition": 1063,
	"./accounting/typeCenterPosition.js": 1063,
	"./accounting/typeDocument": 1064,
	"./accounting/typeDocument.js": 1064,
	"./accounting/typeDocument/filter": 201,
	"./accounting/typeDocument/filter.js": 201,
	"./accounting/typeDocument/table": 202,
	"./accounting/typeDocument/table.js": 202,
	"./accounting/types/filter": 1004,
	"./accounting/types/filter.js": 1004,
	"./accounting/types/table": 200,
	"./accounting/types/table.js": 200,
	"./activateRegistration": 1065,
	"./activateRegistration.js": 1065,
	"./activeProviders": 1066,
	"./activeProviders.js": 1066,
	"./addAdminUserManagement": 1067,
	"./addAdminUserManagement.js": 1067,
	"./addAgentListManagement": 1068,
	"./addAgentListManagement.js": 1068,
	"./addBetShopManagement": 1069,
	"./addBetShopManagement.js": 1069,
	"./adminUser": 1070,
	"./adminUser.js": 1070,
	"./adminUserManagement": 1071,
	"./adminUserManagement.js": 1071,
	"./affiliatesBetShop": 1072,
	"./affiliatesBetShop.js": 1072,
	"./agent/addInformationAgentList": 1073,
	"./agent/addInformationAgentList.js": 1073,
	"./agent/age": 1074,
	"./agent/age.js": 1074,
	"./agent/agent-list/detailsAgentList": 211,
	"./agent/agent-list/detailsAgentList.js": 211,
	"./agent/agent-list/filterAgentList": 212,
	"./agent/agent-list/filterAgentList.js": 212,
	"./agent/agent-list/recordAgentList": 213,
	"./agent/agent-list/recordAgentList.js": 213,
	"./agent/agent-list/recordTableAgentList": 1005,
	"./agent/agent-list/recordTableAgentList.js": 1005,
	"./agent/agent-list/tableAgentList": 214,
	"./agent/agent-list/tableAgentList.js": 214,
	"./agent/agent-retraction/PagoPremio": 215,
	"./agent/agent-retraction/PagoPremio.js": 215,
	"./agent/agent-retraction/search": 216,
	"./agent/agent-retraction/search.js": 216,
	"./agent/agent-retraction/transfers": 217,
	"./agent/agent-retraction/transfers.js": 217,
	"./agent/agent-retraction/transfers1": 218,
	"./agent/agent-retraction/transfers1.js": 218,
	"./agent/agent-transfers/PagoPremio": 219,
	"./agent/agent-transfers/PagoPremio.js": 219,
	"./agent/agent-transfers/search": 220,
	"./agent/agent-transfers/search.js": 220,
	"./agent/agent-transfers/transfers": 221,
	"./agent/agent-transfers/transfers.js": 221,
	"./agent/agent-transfers/transfers1": 222,
	"./agent/agent-transfers/transfers1.js": 222,
	"./agent/agent-tree/details": 1006,
	"./agent/agent-tree/details.js": 1006,
	"./agent/agent-tree/filter": 223,
	"./agent/agent-tree/filter.js": 223,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 224,
	"./agent/agent-tree/recordTableAgentList.js": 224,
	"./agent/agent-tree/table": 225,
	"./agent/agent-tree/table.js": 225,
	"./agent/bonusReportAgentList": 1075,
	"./agent/bonusReportAgentList.js": 1075,
	"./agent/casinoGamesReportAgentList": 1076,
	"./agent/casinoGamesReportAgentList.js": 1076,
	"./agent/comissions": 1077,
	"./agent/comissions.js": 1077,
	"./agent/comissions/autoexclusionUsers": 1078,
	"./agent/comissions/autoexclusionUsers.js": 1078,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1079,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1079,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1080,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1080,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1081,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1081,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1082,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1082,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1083,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1083,
	"./agent/comissions/betsReport/detailsReport": 1084,
	"./agent/comissions/betsReport/detailsReport.js": 1084,
	"./agent/comissions/betsReport/filterReport": 1085,
	"./agent/comissions/betsReport/filterReport.js": 1085,
	"./agent/comissions/betsReport/recordReport": 1086,
	"./agent/comissions/betsReport/recordReport.js": 1086,
	"./agent/comissions/betsReport/recordTableReport": 1087,
	"./agent/comissions/betsReport/recordTableReport.js": 1087,
	"./agent/comissions/betsReport/recordTableTransReport": 1088,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1088,
	"./agent/comissions/betsReport/recordTransReport": 1089,
	"./agent/comissions/betsReport/recordTransReport.js": 1089,
	"./agent/comissions/betsReport/tableReport": 1090,
	"./agent/comissions/betsReport/tableReport.js": 1090,
	"./agent/comissions/betsReportBetShop": 1091,
	"./agent/comissions/betsReportBetShop.js": 1091,
	"./agent/comissions/bonusReport/detailsBonusReport": 1092,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1092,
	"./agent/comissions/bonusReport/filterBonusReport": 1093,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1093,
	"./agent/comissions/bonusReport/recordBonusReport": 1094,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1094,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1095,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1095,
	"./agent/comissions/bonusReport/tableBonusReport": 1096,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1096,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1097,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1097,
	"./agent/comissions/casinoReport/filterCasinoReport": 1098,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1098,
	"./agent/comissions/casinoReport/recordCasinoReport": 1099,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1099,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1100,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1100,
	"./agent/comissions/casinoReport/tableCasinoReport": 1101,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1101,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1102,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1102,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1103,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1103,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1104,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1104,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1105,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1105,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1106,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1106,
	"./agent/comissions/comissions": 1107,
	"./agent/comissions/comissions.js": 1107,
	"./agent/comissions/comissions/table": 234,
	"./agent/comissions/comissions/table.js": 234,
	"./agent/comissions/comissionsReportBetShop": 1108,
	"./agent/comissions/comissionsReportBetShop.js": 1108,
	"./agent/comissions/comissionsReportBetShopDetail": 1109,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1109,
	"./agent/comissions/comissions_report/detailsDepositReports": 1110,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1110,
	"./agent/comissions/comissions_report/filter": 235,
	"./agent/comissions/comissions_report/filter.js": 235,
	"./agent/comissions/comissions_report/recordDepositReports": 1111,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1111,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1112,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1112,
	"./agent/comissions/comissions_report/table": 236,
	"./agent/comissions/comissions_report/table.js": 236,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1113,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1113,
	"./agent/comissions/comissions_report_detail/filter": 237,
	"./agent/comissions/comissions_report_detail/filter.js": 237,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1114,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1114,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1115,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1115,
	"./agent/comissions/comissions_report_detail/table": 238,
	"./agent/comissions/comissions_report_detail/table.js": 238,
	"./agent/comissions/expenses": 1116,
	"./agent/comissions/expenses.js": 1116,
	"./agent/comissions/expenses/filter": 1117,
	"./agent/comissions/expenses/filter.js": 1117,
	"./agent/comissions/expenses/table": 1118,
	"./agent/comissions/expenses/table.js": 1118,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1119,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1119,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1120,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1120,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1121,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1121,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1122,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1122,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1123,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1123,
	"./agent/comissions/incomes": 1124,
	"./agent/comissions/incomes.js": 1124,
	"./agent/comissions/incomes/filter": 1125,
	"./agent/comissions/incomes/filter.js": 1125,
	"./agent/comissions/incomes/table": 1126,
	"./agent/comissions/incomes/table.js": 1126,
	"./agent/comissions/productsThird": 1127,
	"./agent/comissions/productsThird.js": 1127,
	"./agent/comissions/productsThird/filter": 1128,
	"./agent/comissions/productsThird/filter.js": 1128,
	"./agent/comissions/productsThird/table": 1129,
	"./agent/comissions/productsThird/table.js": 1129,
	"./agent/comissions/promotionalCodes": 1130,
	"./agent/comissions/promotionalCodes.js": 1130,
	"./agent/comissions/promotionalCodes/filter": 1131,
	"./agent/comissions/promotionalCodes/filter.js": 1131,
	"./agent/comissions/promotionalCodes/table": 1132,
	"./agent/comissions/promotionalCodes/table.js": 1132,
	"./agent/comissions/withdrawalRequests": 1133,
	"./agent/comissions/withdrawalRequests.js": 1133,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 241,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 241,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 239,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 239,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1134,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1134,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 242,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 242,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 240,
	"./agent/configuration/changePassword": 1135,
	"./agent/configuration/changePassword.js": 1135,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1136,
	"./agent/configuration/generateToken.js": 1136,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1137,
	"./agent/configuration/qrgoogle.js": 1137,
	"./agent/configuration/securityChanges": 1138,
	"./agent/configuration/securityChanges.js": 1138,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1139,
	"./agent/configurationAgentList.js": 1139,
	"./agent/depositReportAgentList": 1140,
	"./agent/depositReportAgentList.js": 1140,
	"./agent/financescustomerAgentList": 1141,
	"./agent/financescustomerAgentList.js": 1141,
	"./agent/financial/comisiones": 1142,
	"./agent/financial/comisiones.js": 1142,
	"./agent/financial/comisiones/table": 245,
	"./agent/financial/comisiones/table.js": 245,
	"./agent/financial/informationFinancialAgentList": 1143,
	"./agent/financial/informationFinancialAgentList.js": 1143,
	"./agent/financial/withdrawalRequestsAgentList": 1144,
	"./agent/financial/withdrawalRequestsAgentList.js": 1144,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 246,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 246,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1145,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1145,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 247,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 247,
	"./agent/flujoCajaAgentList": 1146,
	"./agent/flujoCajaAgentList.js": 1146,
	"./agent/flujoCajaHijosAgentList": 1147,
	"./agent/flujoCajaHijosAgentList.js": 1147,
	"./agent/geo": 1148,
	"./agent/geo.js": 1148,
	"./agent/informationAgentList": 1149,
	"./agent/informationAgentList.js": 1149,
	"./agent/informeRed/details": 1150,
	"./agent/informeRed/details.js": 1150,
	"./agent/informeRed/filter": 254,
	"./agent/informeRed/filter.js": 254,
	"./agent/informeRed/record": 1151,
	"./agent/informeRed/record.js": 1151,
	"./agent/informeRed/recordTable": 1152,
	"./agent/informeRed/recordTable.js": 1152,
	"./agent/informeRed/table": 255,
	"./agent/informeRed/table.js": 255,
	"./agent/money": 1153,
	"./agent/money.js": 1153,
	"./agent/paymenthistory": 1154,
	"./agent/paymenthistory.js": 1154,
	"./agent/positions": 1155,
	"./agent/positions.js": 1155,
	"./agent/reports/autoexclusionUsers": 1156,
	"./agent/reports/autoexclusionUsers.js": 1156,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1157,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1157,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1158,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1158,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1159,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1159,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1160,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1160,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1161,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1161,
	"./agent/reports/balanceTransactionReport": 1162,
	"./agent/reports/balanceTransactionReport.js": 1162,
	"./agent/reports/balanceTransactionReport/filter": 256,
	"./agent/reports/balanceTransactionReport/filter.js": 256,
	"./agent/reports/balanceTransactionReport/table": 257,
	"./agent/reports/balanceTransactionReport/table.js": 257,
	"./agent/reports/betsReport/detailsReport": 1163,
	"./agent/reports/betsReport/detailsReport.js": 1163,
	"./agent/reports/betsReport/filterReport": 258,
	"./agent/reports/betsReport/filterReport.js": 258,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1164,
	"./agent/reports/betsReport/recordTableReport.js": 1164,
	"./agent/reports/betsReport/recordTableTransReport": 1165,
	"./agent/reports/betsReport/recordTableTransReport.js": 1165,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 259,
	"./agent/reports/betsReport/tableReport.js": 259,
	"./agent/reports/betsReportAgentList": 1166,
	"./agent/reports/betsReportAgentList.js": 1166,
	"./agent/reports/bonusReport/detailsBonusReport": 228,
	"./agent/reports/bonusReport/detailsBonusReport.js": 228,
	"./agent/reports/bonusReport/filterBonusReport": 226,
	"./agent/reports/bonusReport/filterBonusReport.js": 226,
	"./agent/reports/bonusReport/recordBonusReport": 229,
	"./agent/reports/bonusReport/recordBonusReport.js": 229,
	"./agent/reports/bonusReport/recordTableBonusReport": 1167,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1167,
	"./agent/reports/bonusReport/tableBonusReport": 227,
	"./agent/reports/bonusReport/tableBonusReport.js": 227,
	"./agent/reports/casinoReport/detailsCasinoReport": 232,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 232,
	"./agent/reports/casinoReport/filterCasinoReport": 230,
	"./agent/reports/casinoReport/filterCasinoReport.js": 230,
	"./agent/reports/casinoReport/recordCasinoReport": 233,
	"./agent/reports/casinoReport/recordCasinoReport.js": 233,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1168,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1168,
	"./agent/reports/casinoReport/tableCasinoReport": 231,
	"./agent/reports/casinoReport/tableCasinoReport.js": 231,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1169,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1169,
	"./agent/reports/casinoReport2/filterCasinoReport": 1170,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1170,
	"./agent/reports/casinoReport2/recordCasinoReport": 1171,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1171,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1172,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1172,
	"./agent/reports/casinoReport2/tableCasinoReport": 1173,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1173,
	"./agent/reports/deposit_report/detailsDepositReports": 1174,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1174,
	"./agent/reports/deposit_report/filterDepositReports": 243,
	"./agent/reports/deposit_report/filterDepositReports.js": 243,
	"./agent/reports/deposit_report/recordDepositReports": 1175,
	"./agent/reports/deposit_report/recordDepositReports.js": 1175,
	"./agent/reports/deposit_report/recordTableDepositReports": 1176,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1176,
	"./agent/reports/deposit_report/tableDepositReports": 244,
	"./agent/reports/deposit_report/tableDepositReports.js": 244,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1177,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1177,
	"./agent/reports/flujocaja/filterFlujoCaja": 248,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 248,
	"./agent/reports/flujocaja/recordFlujoCaja": 1178,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1178,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1179,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1179,
	"./agent/reports/flujocaja/tableFlujoCaja": 249,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 249,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 252,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 252,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 250,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 250,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 253,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 253,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1180,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1180,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 251,
	"./agent/reports/managementReport": 1181,
	"./agent/reports/managementReport.js": 1181,
	"./agent/reports/managementReport/filterReports": 260,
	"./agent/reports/managementReport/filterReports.js": 260,
	"./agent/reports/managementReport/tableReports": 261,
	"./agent/reports/managementReport/tableReports.js": 261,
	"./agent/reports/marketing/filterReports": 262,
	"./agent/reports/marketing/filterReports.js": 262,
	"./agent/reports/marketing/tableReports": 263,
	"./agent/reports/marketing/tableReports.js": 263,
	"./agent/reports/marketingReport": 1182,
	"./agent/reports/marketingReport.js": 1182,
	"./agent/reports/promotionalCodes": 1183,
	"./agent/reports/promotionalCodes.js": 1183,
	"./agent/reports/promotionalCodes/filter": 264,
	"./agent/reports/promotionalCodes/filter.js": 264,
	"./agent/reports/promotionalCodes/table": 265,
	"./agent/reports/promotionalCodes/table.js": 265,
	"./agent/reports/quotaRetractionReport/filter": 266,
	"./agent/reports/quotaRetractionReport/filter.js": 266,
	"./agent/reports/quotaRetractionReport/table": 267,
	"./agent/reports/quotaRetractionReport/table.js": 267,
	"./agent/reports/quotaRetractionReportAgent": 1184,
	"./agent/reports/quotaRetractionReportAgent.js": 1184,
	"./agent/reports/transfersReport/filter": 268,
	"./agent/reports/transfersReport/filter.js": 268,
	"./agent/reports/transfersReport/table": 269,
	"./agent/reports/transfersReport/table.js": 269,
	"./agent/reports/trasnfersReport": 1185,
	"./agent/reports/trasnfersReport.js": 1185,
	"./agent/reports/userAfilliatesReport": 1186,
	"./agent/reports/userAfilliatesReport.js": 1186,
	"./agent/reports/user_affiliates/detailsReports": 272,
	"./agent/reports/user_affiliates/detailsReports.js": 272,
	"./agent/reports/user_affiliates/filterReports": 270,
	"./agent/reports/user_affiliates/filterReports.js": 270,
	"./agent/reports/user_affiliates/recordReports": 273,
	"./agent/reports/user_affiliates/recordReports.js": 273,
	"./agent/reports/user_affiliates/recordTableReports": 1187,
	"./agent/reports/user_affiliates/recordTableReports.js": 1187,
	"./agent/reports/user_affiliates/tableReports": 271,
	"./agent/reports/user_affiliates/tableReports.js": 271,
	"./agent/reportscustomerAgentList": 1188,
	"./agent/reportscustomerAgentList.js": 1188,
	"./agent/requestsAgent": 1189,
	"./agent/requestsAgent.js": 1189,
	"./agent/requestsAgent/filter": 274,
	"./agent/requestsAgent/filter.js": 274,
	"./agent/requestsAgent/table": 275,
	"./agent/requestsAgent/table.js": 275,
	"./agent/requirementsAgent": 1190,
	"./agent/requirementsAgent.js": 1190,
	"./agent/requirementsAgent/details": 278,
	"./agent/requirementsAgent/details.js": 278,
	"./agent/requirementsAgent/detailsFilter": 280,
	"./agent/requirementsAgent/detailsFilter.js": 280,
	"./agent/requirementsAgent/detailsTable": 279,
	"./agent/requirementsAgent/detailsTable.js": 279,
	"./agent/requirementsAgent/filter": 276,
	"./agent/requirementsAgent/filter.js": 276,
	"./agent/requirementsAgent/table": 277,
	"./agent/requirementsAgent/table.js": 277,
	"./agent/statistics/age": 281,
	"./agent/statistics/age.js": 281,
	"./agent/statistics/marketing": 282,
	"./agent/statistics/marketing.js": 282,
	"./agent/statistics/marketingvsregistros": 283,
	"./agent/statistics/marketingvsregistros.js": 283,
	"./agent/statistics/money": 284,
	"./agent/statistics/money.js": 284,
	"./agent/statisticsAgentList": 1191,
	"./agent/statisticsAgentList.js": 1191,
	"./agent/tags": 1192,
	"./agent/tags.js": 1192,
	"./agentList": 1193,
	"./agentList.js": 1193,
	"./agentListManagement": 1194,
	"./agentListManagement.js": 1194,
	"./agentRetraction": 1195,
	"./agentRetraction.js": 1195,
	"./agentTransfers": 1196,
	"./agentTransfers.js": 1196,
	"./agentsInform": 1197,
	"./agentsInform.js": 1197,
	"./agentsTree": 1198,
	"./agentsTree.js": 1198,
	"./alltactions": 285,
	"./alltactions.js": 285,
	"./approvalLogs": 1199,
	"./approvalLogs.js": 1199,
	"./approvalLogs2": 1200,
	"./approvalLogs2.js": 1200,
	"./approvalLogsBetShop": 1201,
	"./approvalLogsBetShop.js": 1201,
	"./assignmentQuotaMade": 1202,
	"./assignmentQuotaMade.js": 1202,
	"./assignmentQuotaR": 1203,
	"./assignmentQuotaR.js": 1203,
	"./autoexclusionUsers": 1204,
	"./autoexclusionUsers.js": 1204,
	"./balanceAdjustments": 1205,
	"./balanceAdjustments.js": 1205,
	"./balanceHistory": 1206,
	"./balanceHistory.js": 1206,
	"./balanceHistory2": 1207,
	"./balanceHistory2.js": 1207,
	"./balanceHistoryAdminUser": 1208,
	"./balanceHistoryAdminUser.js": 1208,
	"./balanceHistoryBetShop": 1209,
	"./balanceHistoryBetShop.js": 1209,
	"./balanceHistoryBetShop2": 1210,
	"./balanceHistoryBetShop2.js": 1210,
	"./balanceHistoryForAgent": 1211,
	"./balanceHistoryForAgent.js": 1211,
	"./balanceHistoryForBetShop": 1212,
	"./balanceHistoryForBetShop.js": 1212,
	"./balanceHistoryMachine": 1213,
	"./balanceHistoryMachine.js": 1213,
	"./balanceUsers": 1214,
	"./balanceUsers.js": 1214,
	"./bankAccounts": 1215,
	"./bankAccounts.js": 1215,
	"./banks": 1216,
	"./banks.js": 1216,
	"./betShop": 1217,
	"./betShop.js": 1217,
	"./betShopCompetence": 1218,
	"./betShopCompetence.js": 1218,
	"./betShopManagement": 1219,
	"./betShopManagement.js": 1219,
	"./betShopManagement/addInformationBetShop": 1220,
	"./betShopManagement/addInformationBetShop.js": 1220,
	"./betShopManagement/age": 1221,
	"./betShopManagement/age.js": 1221,
	"./betShopManagement/betShop/detailsBetShop": 1007,
	"./betShopManagement/betShop/detailsBetShop.js": 1007,
	"./betShopManagement/betShop/filterBetShop": 326,
	"./betShopManagement/betShop/filterBetShop.js": 326,
	"./betShopManagement/betShop/recordBetShop": 328,
	"./betShopManagement/betShop/recordBetShop.js": 328,
	"./betShopManagement/betShop/recordTableBetShop": 89,
	"./betShopManagement/betShop/recordTableBetShop.js": 89,
	"./betShopManagement/betShop/tableBetShop": 327,
	"./betShopManagement/betShop/tableBetShop.js": 327,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1222,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1222,
	"./betShopManagement/betShopCompetence/filterBetShop": 329,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 329,
	"./betShopManagement/betShopCompetence/recordBetShop": 1223,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1223,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1224,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1224,
	"./betShopManagement/betShopCompetence/tableBetShop": 330,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 330,
	"./betShopManagement/bonusReportBetShop": 1225,
	"./betShopManagement/bonusReportBetShop.js": 1225,
	"./betShopManagement/cashier/betShopAdvertising": 335,
	"./betShopManagement/cashier/betShopAdvertising.js": 335,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 337,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 337,
	"./betShopManagement/cashier/betShopCashier": 1226,
	"./betShopManagement/cashier/betShopCashier.js": 1226,
	"./betShopManagement/cashier/betShopComissions": 1008,
	"./betShopManagement/cashier/betShopComissions.js": 1008,
	"./betShopManagement/cashier/filterCashier": 340,
	"./betShopManagement/cashier/filterCashier.js": 340,
	"./betShopManagement/cashier/tableAdvertising": 336,
	"./betShopManagement/cashier/tableAdvertising.js": 336,
	"./betShopManagement/cashier/tableAdvertisingCashier": 338,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 338,
	"./betShopManagement/cashier/tableCashier": 90,
	"./betShopManagement/cashier/tableCashier.js": 90,
	"./betShopManagement/cashier/tableComissions": 339,
	"./betShopManagement/cashier/tableComissions.js": 339,
	"./betShopManagement/casinoGamesReportBetShop": 1227,
	"./betShopManagement/casinoGamesReportBetShop.js": 1227,
	"./betShopManagement/comissions": 1228,
	"./betShopManagement/comissions.js": 1228,
	"./betShopManagement/comissions/autoexclusionUsers": 1229,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1229,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1230,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1230,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1231,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1231,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1232,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1232,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1233,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1233,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1234,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1234,
	"./betShopManagement/comissions/betsReport/detailsReport": 1235,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1235,
	"./betShopManagement/comissions/betsReport/filterReport": 1236,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1236,
	"./betShopManagement/comissions/betsReport/recordReport": 1237,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1237,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1238,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1238,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1239,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1239,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1240,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1240,
	"./betShopManagement/comissions/betsReport/tableReport": 1241,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1241,
	"./betShopManagement/comissions/betsReportBetShop": 1242,
	"./betShopManagement/comissions/betsReportBetShop.js": 1242,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1243,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1243,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1244,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1244,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1245,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1245,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1246,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1246,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1247,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1247,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1248,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1248,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1249,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1249,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1250,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1250,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1251,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1251,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1252,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1252,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1253,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1253,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1254,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1254,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1255,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1255,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1256,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1256,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1257,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1257,
	"./betShopManagement/comissions/comissions": 1258,
	"./betShopManagement/comissions/comissions.js": 1258,
	"./betShopManagement/comissions/comissions/table": 345,
	"./betShopManagement/comissions/comissions/table.js": 345,
	"./betShopManagement/comissions/comissionsReportBetShop": 1259,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1259,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1260,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1260,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1261,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1261,
	"./betShopManagement/comissions/comissions_report/filter": 346,
	"./betShopManagement/comissions/comissions_report/filter.js": 346,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1262,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1262,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1263,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1263,
	"./betShopManagement/comissions/comissions_report/table": 347,
	"./betShopManagement/comissions/comissions_report/table.js": 347,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1264,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1264,
	"./betShopManagement/comissions/comissions_report_detail/filter": 348,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 348,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1265,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1265,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1266,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1266,
	"./betShopManagement/comissions/comissions_report_detail/table": 349,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 349,
	"./betShopManagement/comissions/expenses": 1267,
	"./betShopManagement/comissions/expenses.js": 1267,
	"./betShopManagement/comissions/expenses/filter": 1268,
	"./betShopManagement/comissions/expenses/filter.js": 1268,
	"./betShopManagement/comissions/expenses/table": 1269,
	"./betShopManagement/comissions/expenses/table.js": 1269,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1270,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1270,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1271,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1271,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1272,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1272,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1273,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1273,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1274,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1274,
	"./betShopManagement/comissions/incomes": 1275,
	"./betShopManagement/comissions/incomes.js": 1275,
	"./betShopManagement/comissions/incomes/filter": 1276,
	"./betShopManagement/comissions/incomes/filter.js": 1276,
	"./betShopManagement/comissions/incomes/table": 1277,
	"./betShopManagement/comissions/incomes/table.js": 1277,
	"./betShopManagement/comissions/productsThird": 1278,
	"./betShopManagement/comissions/productsThird.js": 1278,
	"./betShopManagement/comissions/productsThird/filter": 1279,
	"./betShopManagement/comissions/productsThird/filter.js": 1279,
	"./betShopManagement/comissions/productsThird/table": 1280,
	"./betShopManagement/comissions/productsThird/table.js": 1280,
	"./betShopManagement/comissions/promotionalCodes": 1281,
	"./betShopManagement/comissions/promotionalCodes.js": 1281,
	"./betShopManagement/comissions/promotionalCodes/filter": 1282,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1282,
	"./betShopManagement/comissions/promotionalCodes/table": 1283,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1283,
	"./betShopManagement/comissions/withdrawalRequests": 1284,
	"./betShopManagement/comissions/withdrawalRequests.js": 1284,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 352,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 352,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 350,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 350,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1285,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1285,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 353,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 353,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 351,
	"./betShopManagement/configuration/changePassword": 1286,
	"./betShopManagement/configuration/changePassword.js": 1286,
	"./betShopManagement/configuration/changePassword/changePasswordView": 354,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 354,
	"./betShopManagement/configuration/configNtc": 1287,
	"./betShopManagement/configuration/configNtc.js": 1287,
	"./betShopManagement/configuration/configNtc/configNtcView": 355,
	"./betShopManagement/configuration/configNtc/configNtcView.js": 355,
	"./betShopManagement/configuration/generateToken": 1288,
	"./betShopManagement/configuration/generateToken.js": 1288,
	"./betShopManagement/configuration/generateToken/filter": 356,
	"./betShopManagement/configuration/generateToken/filter.js": 356,
	"./betShopManagement/configuration/generateToken/table": 357,
	"./betShopManagement/configuration/generateToken/table.js": 357,
	"./betShopManagement/configuration/qrgoogle": 1289,
	"./betShopManagement/configuration/qrgoogle.js": 1289,
	"./betShopManagement/configuration/securityChanges": 1290,
	"./betShopManagement/configuration/securityChanges.js": 1290,
	"./betShopManagement/configuration/securityChanges/filter": 1009,
	"./betShopManagement/configuration/securityChanges/filter.js": 1009,
	"./betShopManagement/configuration/securityChanges/table": 358,
	"./betShopManagement/configuration/securityChanges/table.js": 358,
	"./betShopManagement/configurationBetShop": 1291,
	"./betShopManagement/configurationBetShop.js": 1291,
	"./betShopManagement/depositReportBetShop": 1292,
	"./betShopManagement/depositReportBetShop.js": 1292,
	"./betShopManagement/financescustomerBetShop": 1293,
	"./betShopManagement/financescustomerBetShop.js": 1293,
	"./betShopManagement/financial/bankAccountsBetShop": 1294,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1294,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1295,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1295,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 361,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 361,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1296,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1296,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1297,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1297,
	"./betShopManagement/financial/bankAccountsBetShop/table": 362,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 362,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1298,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1298,
	"./betShopManagement/financial/informationFinancialBetShop": 1299,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1299,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1300,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1300,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 363,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 365,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 364,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 364,
	"./betShopManagement/flujoCajaBetShop": 1301,
	"./betShopManagement/flujoCajaBetShop.js": 1301,
	"./betShopManagement/geo": 1302,
	"./betShopManagement/geo.js": 1302,
	"./betShopManagement/informationBetShop": 1303,
	"./betShopManagement/informationBetShop.js": 1303,
	"./betShopManagement/money": 1304,
	"./betShopManagement/money.js": 1304,
	"./betShopManagement/paymenthistory": 1305,
	"./betShopManagement/paymenthistory.js": 1305,
	"./betShopManagement/positions": 1306,
	"./betShopManagement/positions.js": 1306,
	"./betShopManagement/reports/autoexclusionUsers": 1307,
	"./betShopManagement/reports/autoexclusionUsers.js": 1307,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1308,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1308,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1309,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1309,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1310,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1310,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1311,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1311,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1312,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1312,
	"./betShopManagement/reports/balanceTransactionReport": 1313,
	"./betShopManagement/reports/balanceTransactionReport.js": 1313,
	"./betShopManagement/reports/balanceTransactionReport/filter": 368,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 368,
	"./betShopManagement/reports/balanceTransactionReport/table": 369,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 369,
	"./betShopManagement/reports/betsReport/detailsReport": 1314,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1314,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1315,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1315,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 88,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 88,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1316,
	"./betShopManagement/reports/betsReportBetShop.js": 1316,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 333,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 333,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 331,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 331,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 334,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 334,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1317,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1317,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 332,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 332,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 343,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 343,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 341,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 341,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 344,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 344,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1318,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1318,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1319,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1319,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1320,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1320,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1321,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1321,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1322,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1322,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1323,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1323,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 1010,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 1010,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 359,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 359,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1324,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1324,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 360,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 360,
	"./betShopManagement/reports/expenses": 1325,
	"./betShopManagement/reports/expenses.js": 1325,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1326,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1326,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 366,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 366,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1327,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1327,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1328,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1328,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 367,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 367,
	"./betShopManagement/reports/historyMovement": 1329,
	"./betShopManagement/reports/historyMovement.js": 1329,
	"./betShopManagement/reports/historyMovement/filter": 370,
	"./betShopManagement/reports/historyMovement/filter.js": 370,
	"./betShopManagement/reports/historyMovement/table": 371,
	"./betShopManagement/reports/historyMovement/table.js": 371,
	"./betShopManagement/reports/incomes": 1330,
	"./betShopManagement/reports/incomes.js": 1330,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1331,
	"./betShopManagement/reports/productsThird.js": 1331,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1332,
	"./betShopManagement/reports/promotionalCodes.js": 1332,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1333,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1333,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 372,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 373,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 373,
	"./betShopManagement/reportscustomerBetShop": 1334,
	"./betShopManagement/reportscustomerBetShop.js": 1334,
	"./betShopManagement/statisticsBetShop": 1335,
	"./betShopManagement/statisticsBetShop.js": 1335,
	"./betShopManagement/tags": 1336,
	"./betShopManagement/tags.js": 1336,
	"./betsHistory": 1337,
	"./betsHistory.js": 1337,
	"./betsHistory2": 1338,
	"./betsHistory2.js": 1338,
	"./betsReport": 1339,
	"./betsReport.js": 1339,
	"./betsReportBetShop": 1340,
	"./betsReportBetShop.js": 1340,
	"./betsReportSecond": 1341,
	"./betsReportSecond.js": 1341,
	"./betsSport": 1342,
	"./betsSport.js": 1342,
	"./betsSportLive": 1343,
	"./betsSportLive.js": 1343,
	"./betsVirtual": 1344,
	"./betsVirtual.js": 1344,
	"./betting": 1345,
	"./betting.js": 1345,
	"./bettingVirtual": 1346,
	"./bettingVirtual.js": 1346,
	"./blockchains": 1347,
	"./blockchains.js": 1347,
	"./bonusReport": 1348,
	"./bonusReport.js": 1348,
	"./bonusReport2": 1349,
	"./bonusReport2.js": 1349,
	"./cash/bankAccounts/filter": 321,
	"./cash/bankAccounts/filter.js": 321,
	"./cash/bankAccounts/table": 322,
	"./cash/bankAccounts/table.js": 322,
	"./cash/bets/betHistory": 91,
	"./cash/bets/betHistory.js": 91,
	"./cash/bets/betHistory2": 1350,
	"./cash/bets/betHistory2.js": 1350,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 378,
	"./cash/bets/sportLive.js": 378,
	"./cash/bets/sportVirtual": 379,
	"./cash/bets/sportVirtual.js": 379,
	"./cash/closeBox-edit/creditCards": 386,
	"./cash/closeBox-edit/creditCards.js": 386,
	"./cash/closeBox-edit/otherExpenses": 387,
	"./cash/closeBox-edit/otherExpenses.js": 387,
	"./cash/closeBox-edit/otherIncome": 388,
	"./cash/closeBox-edit/otherIncome.js": 388,
	"./cash/closeBox-edit/products": 389,
	"./cash/closeBox-edit/products.js": 389,
	"./cash/closeBox-edit/total": 390,
	"./cash/closeBox-edit/total.js": 390,
	"./cash/closeBox-old/otherExpenses": 1351,
	"./cash/closeBox-old/otherExpenses.js": 1351,
	"./cash/closeBox-old/otherIncome": 1352,
	"./cash/closeBox-old/otherIncome.js": 1352,
	"./cash/closeBox-old/products": 1353,
	"./cash/closeBox-old/products.js": 1353,
	"./cash/closeBox-old/total": 1354,
	"./cash/closeBox-old/total.js": 1354,
	"./cash/closeBox/creditCards": 391,
	"./cash/closeBox/creditCards.js": 391,
	"./cash/closeBox/otherExpenses": 95,
	"./cash/closeBox/otherExpenses.js": 95,
	"./cash/closeBox/otherIncome": 96,
	"./cash/closeBox/otherIncome.js": 96,
	"./cash/closeBox/products": 97,
	"./cash/closeBox/products.js": 97,
	"./cash/closeBox/total": 98,
	"./cash/closeBox/total.js": 98,
	"./cash/flujocaja/detailsFlujoCaja": 392,
	"./cash/flujocaja/detailsFlujoCaja.js": 392,
	"./cash/flujocaja/filterFlujoCaja": 393,
	"./cash/flujocaja/filterFlujoCaja.js": 393,
	"./cash/flujocaja/recordFlujoCaja": 394,
	"./cash/flujocaja/recordFlujoCaja.js": 394,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 395,
	"./cash/flujocaja/tableFlujoCaja.js": 395,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 396,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 396,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 397,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 397,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 1011,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 1011,
	"./cash/pagopremio/PagoPremio": 398,
	"./cash/pagopremio/PagoPremio.js": 398,
	"./cash/pagopremio/detailsPagoPremio": 399,
	"./cash/pagopremio/detailsPagoPremio.js": 399,
	"./cash/pagopremio/filterPagoPremio": 400,
	"./cash/pagopremio/filterPagoPremio.js": 400,
	"./cash/pagopremio/recordPagoPremio": 401,
	"./cash/pagopremio/recordPagoPremio.js": 401,
	"./cash/pagopremio/recordTablePagoPremio": 1355,
	"./cash/pagopremio/recordTablePagoPremio.js": 1355,
	"./cash/pagopremio/tablePagoPremio": 402,
	"./cash/pagopremio/tablePagoPremio.js": 402,
	"./cash/pagopremiovirtuales/PagoPremio": 403,
	"./cash/pagopremiovirtuales/PagoPremio.js": 403,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 404,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 404,
	"./cash/pagopremiovirtuales/filterPagoPremio": 405,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 405,
	"./cash/pagopremiovirtuales/recordPagoPremio": 406,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 406,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1356,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1356,
	"./cash/pagopremiovirtuales/tablePagoPremio": 407,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 407,
	"./cash/payPrizesLoyalty/PagoPremio": 408,
	"./cash/payPrizesLoyalty/PagoPremio.js": 408,
	"./cash/payPrizesLoyalty/filterPagoPremio": 409,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 409,
	"./cash/recargacredito/RecargaCredito": 410,
	"./cash/recargacredito/RecargaCredito.js": 410,
	"./cash/recargacredito/filterRecargaCredito": 411,
	"./cash/recargacredito/filterRecargaCredito.js": 411,
	"./cash/recargacreditoAgent/RecargaCredito": 412,
	"./cash/recargacreditoAgent/RecargaCredito.js": 412,
	"./cash/recargacreditoAgent/filterRecargaCredito": 413,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 413,
	"./cash/withdrawal/filter": 414,
	"./cash/withdrawal/filter.js": 414,
	"./cash/withdrawal/table": 415,
	"./cash/withdrawal/table.js": 415,
	"./cashiers": 1357,
	"./cashiers.js": 1357,
	"./casinoGamesReport": 1358,
	"./casinoGamesReport.js": 1358,
	"./casinoGamesReport2": 1359,
	"./casinoGamesReport2.js": 1359,
	"./categories": 1360,
	"./categories.js": 1360,
	"./categoriesProducts": 1361,
	"./categoriesProducts.js": 1361,
	"./closeBox": 1362,
	"./closeBox-old": 1363,
	"./closeBox-old.js": 1363,
	"./closeBox.js": 1362,
	"./closeBoxEdit": 1364,
	"./closeBoxEdit.js": 1364,
	"./comissionsReport": 1365,
	"./comissionsReport.js": 1365,
	"./comissionsReport2": 1366,
	"./comissionsReport2.js": 1366,
	"./commisionsPay": 1367,
	"./commisionsPay.js": 1367,
	"./competitors/competitors": 1368,
	"./competitors/competitors.js": 1368,
	"./competitors/filter": 432,
	"./competitors/filter.js": 432,
	"./competitors/table": 433,
	"./competitors/table.js": 433,
	"./consolidatedIncomeOwner": 1369,
	"./consolidatedIncomeOwner.js": 1369,
	"./consolidatedIncomeOwner2": 1370,
	"./consolidatedIncomeOwner2.js": 1370,
	"./contingency": 1371,
	"./contingency.js": 1371,
	"./countries": 1372,
	"./countries.js": 1372,
	"./coupons": 1373,
	"./coupons.js": 1373,
	"./couponsReport": 1374,
	"./couponsReport.js": 1374,
	"./cryptoBlockchain": 1375,
	"./cryptoBlockchain.js": 1375,
	"./cryptos": 1376,
	"./cryptos.js": 1376,
	"./customReport": 1377,
	"./customReport.js": 1377,
	"./customers": 1378,
	"./customers.js": 1378,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1379,
	"./customers/bonusReport.js": 1379,
	"./customers/bonusReport2": 1380,
	"./customers/bonusReport2.js": 1380,
	"./customers/casinoGamesReport": 1381,
	"./customers/casinoGamesReport.js": 1381,
	"./customers/configuration": 1382,
	"./customers/configuration.js": 1382,
	"./customers/configuration/changePassword": 1383,
	"./customers/configuration/changePassword.js": 1383,
	"./customers/configuration/changePassword/changePasswordView": 103,
	"./customers/configuration/changePassword/changePasswordView.js": 103,
	"./customers/configuration/generateToken": 1384,
	"./customers/configuration/generateToken.js": 1384,
	"./customers/configuration/generateToken/filter": 104,
	"./customers/configuration/generateToken/filter.js": 104,
	"./customers/configuration/generateToken/table": 105,
	"./customers/configuration/generateToken/table.js": 105,
	"./customers/configuration/limitChanges": 1385,
	"./customers/configuration/limitChanges.js": 1385,
	"./customers/configuration/securityChanges": 1386,
	"./customers/configuration/securityChanges.js": 1386,
	"./customers/configuration/securityChanges/filter": 82,
	"./customers/configuration/securityChanges/filter.js": 82,
	"./customers/configuration/securityChanges/securityForm": 84,
	"./customers/configuration/securityChanges/securityForm.js": 84,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1387,
	"./customers/configuration/securityChanges2.js": 1387,
	"./customers/depositReport": 1388,
	"./customers/depositReport.js": 1388,
	"./customers/financescustomer": 1389,
	"./customers/financescustomer.js": 1389,
	"./customers/financial/bankAccounts": 1390,
	"./customers/financial/bankAccounts.js": 1390,
	"./customers/financial/bankAccounts/details": 1016,
	"./customers/financial/bankAccounts/details.js": 1016,
	"./customers/financial/bankAccounts/filter": 108,
	"./customers/financial/bankAccounts/filter.js": 108,
	"./customers/financial/bankAccounts/record": 453,
	"./customers/financial/bankAccounts/record.js": 453,
	"./customers/financial/bankAccounts/recordTable": 1391,
	"./customers/financial/bankAccounts/recordTable.js": 1391,
	"./customers/financial/bankAccounts/table": 109,
	"./customers/financial/bankAccounts/table.js": 109,
	"./customers/financial/bankAccounts/tablePopup": 1392,
	"./customers/financial/bankAccounts/tablePopup.js": 1392,
	"./customers/financial/informationFinancial": 1393,
	"./customers/financial/informationFinancial.js": 1393,
	"./customers/financial/withdrawalRequests": 1394,
	"./customers/financial/withdrawalRequests.js": 1394,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 110,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 110,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 111,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1395,
	"./customers/information.js": 1395,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 454,
	"./customers/paymenthistory.js": 454,
	"./customers/players/filter": 455,
	"./customers/players/filter.js": 455,
	"./customers/players/table": 456,
	"./customers/players/table.js": 456,
	"./customers/players2/filter": 457,
	"./customers/players2/filter.js": 457,
	"./customers/players2/table": 458,
	"./customers/players2/table.js": 458,
	"./customers/playersAggregator/filter": 459,
	"./customers/playersAggregator/filter.js": 459,
	"./customers/playersAggregator/table": 460,
	"./customers/playersAggregator/table.js": 460,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1396,
	"./customers/referralsReport.js": 1396,
	"./customers/reports/autoexclusionUsers": 1397,
	"./customers/reports/autoexclusionUsers.js": 1397,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 87,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 87,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1398,
	"./customers/reports/balanceAdjustments.js": 1398,
	"./customers/reports/balanceAdjustments/filter": 463,
	"./customers/reports/balanceAdjustments/filter.js": 463,
	"./customers/reports/balanceAdjustments/table": 464,
	"./customers/reports/balanceAdjustments/table.js": 464,
	"./customers/reports/balanceHistory": 1399,
	"./customers/reports/balanceHistory.js": 1399,
	"./customers/reports/balanceHistory/filter": 465,
	"./customers/reports/balanceHistory/filter.js": 465,
	"./customers/reports/balanceHistory/table": 466,
	"./customers/reports/balanceHistory/table.js": 466,
	"./customers/reports/betsReport": 1400,
	"./customers/reports/betsReport.js": 1400,
	"./customers/reports/betsReport/detailsReport": 1401,
	"./customers/reports/betsReport/detailsReport.js": 1401,
	"./customers/reports/betsReport/filterReport": 112,
	"./customers/reports/betsReport/filterReport.js": 112,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 113,
	"./customers/reports/betsReport/tableReport.js": 113,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 99,
	"./customers/reports/bonusReport/filterBonusReport.js": 99,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 100,
	"./customers/reports/bonusReport/tableBonusReport.js": 100,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 451,
	"./customers/reports/bonusReport2/filterBonusReport.js": 451,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1402,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1402,
	"./customers/reports/bonusReport2/tableBonusReport": 452,
	"./customers/reports/bonusReport2/tableBonusReport.js": 452,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 101,
	"./customers/reports/casinoReport/filterCasinoReport.js": 101,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 102,
	"./customers/reports/casinoReport/tableCasinoReport.js": 102,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1403,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1403,
	"./customers/reports/casinoReport2/filterCasinoReport": 1404,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1404,
	"./customers/reports/casinoReport2/recordCasinoReport": 1405,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1405,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1406,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1406,
	"./customers/reports/casinoReport2/tableCasinoReport": 1407,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1407,
	"./customers/reports/deposit_report/detailsDepositReports": 169,
	"./customers/reports/deposit_report/detailsDepositReports.js": 169,
	"./customers/reports/deposit_report/filterDepositReports": 106,
	"./customers/reports/deposit_report/filterDepositReports.js": 106,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 107,
	"./customers/reports/deposit_report/tableDepositReports.js": 107,
	"./customers/reports/historyMovement": 1408,
	"./customers/reports/historyMovement.js": 1408,
	"./customers/reports/historyMovement/filter": 467,
	"./customers/reports/historyMovement/filter.js": 467,
	"./customers/reports/historyMovement/table": 468,
	"./customers/reports/historyMovement/table.js": 468,
	"./customers/reports/historyPoints": 1409,
	"./customers/reports/historyPoints.js": 1409,
	"./customers/reports/historyPoints/filter": 469,
	"./customers/reports/historyPoints/filter.js": 469,
	"./customers/reports/historyPoints/table": 470,
	"./customers/reports/historyPoints/table.js": 470,
	"./customers/reports/logsUser": 1410,
	"./customers/reports/logsUser.js": 1410,
	"./customers/reports/logsUser/filter": 471,
	"./customers/reports/logsUser/filter.js": 471,
	"./customers/reports/logsUser/table": 472,
	"./customers/reports/logsUser/table.js": 472,
	"./customers/reports/loyaltyLevelChangeHistory": 1017,
	"./customers/reports/loyaltyLevelChangeHistory.js": 1017,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 473,
	"./customers/reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 473,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 474,
	"./customers/reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 474,
	"./customers/reports/notesUser": 1411,
	"./customers/reports/notesUser.js": 1411,
	"./customers/reports/notesUser/filter": 475,
	"./customers/reports/notesUser/filter.js": 475,
	"./customers/reports/notesUser/table": 476,
	"./customers/reports/notesUser/table.js": 476,
	"./customers/reports/playerPrizesLoyalty": 1412,
	"./customers/reports/playerPrizesLoyalty.js": 1412,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty": 477,
	"./customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty.js": 477,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty": 478,
	"./customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty.js": 478,
	"./customers/reports/playerRoulette": 1413,
	"./customers/reports/playerRoulette.js": 1413,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport": 479,
	"./customers/reports/playerRouletteReport/filterPlayerRouletteReport.js": 479,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport": 480,
	"./customers/reports/playerRouletteReport/tablePlayerRouletteReport.js": 480,
	"./customers/reports/qualifyingPointsRecord": 1414,
	"./customers/reports/qualifyingPointsRecord.js": 1414,
	"./customers/reports/qualifyingPointsRecordReport/filter": 481,
	"./customers/reports/qualifyingPointsRecordReport/filter.js": 481,
	"./customers/reports/qualifyingPointsRecordReport/table": 482,
	"./customers/reports/qualifyingPointsRecordReport/table.js": 482,
	"./customers/reports/referralsReport/filterReferralsReports": 461,
	"./customers/reports/referralsReport/filterReferralsReports.js": 461,
	"./customers/reports/referralsReport/recordReferralsReports": 1415,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1415,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1416,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1416,
	"./customers/reports/referralsReport/tableReferralsReports": 462,
	"./customers/reports/referralsReport/tableReferralsReports.js": 462,
	"./customers/reports/registeredDocument": 1417,
	"./customers/reports/registeredDocument.js": 1417,
	"./customers/reports/registeredDocuments/filter": 483,
	"./customers/reports/registeredDocuments/filter.js": 483,
	"./customers/reports/registeredDocuments/table": 484,
	"./customers/reports/registeredDocuments/table.js": 484,
	"./customers/reports/sessionsReport": 1418,
	"./customers/reports/sessionsReport.js": 1418,
	"./customers/reports/sessionsReport/detailsSessionsReport": 487,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 487,
	"./customers/reports/sessionsReport/filterSessionsReport": 485,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 485,
	"./customers/reports/sessionsReport/recordSessionsReport": 1018,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 1018,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 1019,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 1019,
	"./customers/reports/sessionsReport/tableSessionsReport": 486,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 486,
	"./customers/reports/sessionsReport2": 1419,
	"./customers/reports/sessionsReport2.js": 1419,
	"./customers/reports/sessionsReport2/filter": 488,
	"./customers/reports/sessionsReport2/filter.js": 488,
	"./customers/reports/sessionsReport2/table": 489,
	"./customers/reports/sessionsReport2/table.js": 489,
	"./customers/reports/walletsReport": 1420,
	"./customers/reports/walletsReport.js": 1420,
	"./customers/reports/walletsReport/filter": 490,
	"./customers/reports/walletsReport/filter.js": 490,
	"./customers/reports/walletsReport/table": 491,
	"./customers/reports/walletsReport/table.js": 491,
	"./customers/reportscustomer": 1421,
	"./customers/reportscustomer.js": 1421,
	"./customers/statistics": 1422,
	"./customers/statistics.js": 1422,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1423,
	"./customersAggregator.js": 1423,
	"./customersAggregator/age": 1424,
	"./customersAggregator/age.js": 1424,
	"./customersAggregator/bonusReport": 1425,
	"./customersAggregator/bonusReport.js": 1425,
	"./customersAggregator/casinoGamesReport": 1426,
	"./customersAggregator/casinoGamesReport.js": 1426,
	"./customersAggregator/configuration": 1427,
	"./customersAggregator/configuration.js": 1427,
	"./customersAggregator/configuration/changePassword": 1428,
	"./customersAggregator/configuration/changePassword.js": 1428,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1429,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1429,
	"./customersAggregator/configuration/generateToken": 1430,
	"./customersAggregator/configuration/generateToken.js": 1430,
	"./customersAggregator/configuration/generateToken/filter": 1431,
	"./customersAggregator/configuration/generateToken/filter.js": 1431,
	"./customersAggregator/configuration/generateToken/table": 1432,
	"./customersAggregator/configuration/generateToken/table.js": 1432,
	"./customersAggregator/configuration/securityChanges": 1433,
	"./customersAggregator/configuration/securityChanges.js": 1433,
	"./customersAggregator/configuration/securityChanges/filter": 1434,
	"./customersAggregator/configuration/securityChanges/filter.js": 1434,
	"./customersAggregator/configuration/securityChanges/table": 1435,
	"./customersAggregator/configuration/securityChanges/table.js": 1435,
	"./customersAggregator/depositReport": 1436,
	"./customersAggregator/depositReport.js": 1436,
	"./customersAggregator/financescustomer": 1437,
	"./customersAggregator/financescustomer.js": 1437,
	"./customersAggregator/financial/bankAccounts": 1438,
	"./customersAggregator/financial/bankAccounts.js": 1438,
	"./customersAggregator/financial/bankAccounts/details": 1439,
	"./customersAggregator/financial/bankAccounts/details.js": 1439,
	"./customersAggregator/financial/bankAccounts/filter": 1440,
	"./customersAggregator/financial/bankAccounts/filter.js": 1440,
	"./customersAggregator/financial/bankAccounts/record": 1441,
	"./customersAggregator/financial/bankAccounts/record.js": 1441,
	"./customersAggregator/financial/bankAccounts/recordTable": 1442,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1442,
	"./customersAggregator/financial/bankAccounts/table": 1443,
	"./customersAggregator/financial/bankAccounts/table.js": 1443,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1444,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1444,
	"./customersAggregator/financial/informationFinancial": 1445,
	"./customersAggregator/financial/informationFinancial.js": 1445,
	"./customersAggregator/financial/withdrawalRequests": 1446,
	"./customersAggregator/financial/withdrawalRequests.js": 1446,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1447,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1447,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1448,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1448,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1449,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1449,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1450,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1450,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1451,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1451,
	"./customersAggregator/geo": 1452,
	"./customersAggregator/geo.js": 1452,
	"./customersAggregator/information": 1453,
	"./customersAggregator/information.js": 1453,
	"./customersAggregator/money": 1454,
	"./customersAggregator/money.js": 1454,
	"./customersAggregator/paymenthistory": 1455,
	"./customersAggregator/paymenthistory.js": 1455,
	"./customersAggregator/players/filter": 1456,
	"./customersAggregator/players/filter.js": 1456,
	"./customersAggregator/players/table": 1457,
	"./customersAggregator/players/table.js": 1457,
	"./customersAggregator/playersAggregator/filter": 1458,
	"./customersAggregator/playersAggregator/filter.js": 1458,
	"./customersAggregator/playersAggregator/table": 1459,
	"./customersAggregator/playersAggregator/table.js": 1459,
	"./customersAggregator/positions": 1460,
	"./customersAggregator/positions.js": 1460,
	"./customersAggregator/reports/autoexclusionUsers": 1461,
	"./customersAggregator/reports/autoexclusionUsers.js": 1461,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1462,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1462,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1463,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1463,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1464,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1464,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1465,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1465,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1466,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1466,
	"./customersAggregator/reports/betsReport": 1467,
	"./customersAggregator/reports/betsReport.js": 1467,
	"./customersAggregator/reports/betsReport/detailsReport": 1468,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1468,
	"./customersAggregator/reports/betsReport/filterReport": 1469,
	"./customersAggregator/reports/betsReport/filterReport.js": 1469,
	"./customersAggregator/reports/betsReport/recordReport": 1470,
	"./customersAggregator/reports/betsReport/recordReport.js": 1470,
	"./customersAggregator/reports/betsReport/recordTableReport": 1471,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1471,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1472,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1472,
	"./customersAggregator/reports/betsReport/recordTransReport": 1473,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1473,
	"./customersAggregator/reports/betsReport/tableReport": 1474,
	"./customersAggregator/reports/betsReport/tableReport.js": 1474,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1475,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1475,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1476,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1476,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1477,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1477,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1478,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1478,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1479,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1479,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1480,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1480,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1481,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1481,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1482,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1482,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1483,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1483,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1484,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1484,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1485,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1485,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1486,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1486,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1487,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1487,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1488,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1488,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1489,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1489,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1490,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1490,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1491,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1491,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1492,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1492,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1493,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1493,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1494,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1494,
	"./customersAggregator/reportscustomer": 1495,
	"./customersAggregator/reportscustomer.js": 1495,
	"./customersAggregator/statistics": 1496,
	"./customersAggregator/statistics.js": 1496,
	"./customersAggregator/tags": 1497,
	"./customersAggregator/tags.js": 1497,
	"./dashboard": 1498,
	"./dashboard.js": 1498,
	"./dashboard/dataview": 86,
	"./dashboard/dataview.js": 86,
	"./dashboard/jugadoresActivos": 83,
	"./dashboard/jugadoresActivos.js": 83,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 492,
	"./dates.js": 492,
	"./demos": 1499,
	"./demos.js": 1499,
	"./depositReport": 1500,
	"./depositReport.js": 1500,
	"./depositReport2": 1501,
	"./depositReport2.js": 1501,
	"./depositReport3": 1502,
	"./depositReport3.js": 1502,
	"./depositReportBetShop": 1503,
	"./depositReportBetShop.js": 1503,
	"./depositRequests": 1504,
	"./depositRequests.js": 1504,
	"./eliminateNoteWithdraw": 1505,
	"./eliminateNoteWithdraw.js": 1505,
	"./emailsReport": 1506,
	"./emailsReport.js": 1506,
	"./financial/depositRequests/filter": 501,
	"./financial/depositRequests/filter.js": 501,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 503,
	"./financial/depositRequests/recordTable.js": 503,
	"./financial/depositRequests/table": 502,
	"./financial/depositRequests/table.js": 502,
	"./financial/withdrawalRequests": 1507,
	"./financial/withdrawalRequests.js": 1507,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 114,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 114,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 115,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 115,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 510,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 510,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1508,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1508,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 511,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 511,
	"./flujoCaja": 1509,
	"./flujoCaja.js": 1509,
	"./franchisee": 1510,
	"./franchisee.js": 1510,
	"./franchises": 1511,
	"./franchises.js": 1511,
	"./futureEvents": 1512,
	"./futureEvents.js": 1512,
	"./gamePerformanceReport": 1513,
	"./gamePerformanceReport.js": 1513,
	"./getReportStructureGames": 1514,
	"./getReportStructureGames.js": 1514,
	"./goldenRace": 1515,
	"./goldenRace.js": 1515,
	"./historicalCashFlow": 1516,
	"./historicalCashFlow.js": 1516,
	"./historyMovement": 1517,
	"./historyMovement.js": 1517,
	"./historyMovement/filter": 1518,
	"./historyMovement/filter.js": 1518,
	"./historyMovement/table": 1519,
	"./historyMovement/table.js": 1519,
	"./historyMovementBetShop": 1520,
	"./historyMovementBetShop.js": 1520,
	"./historyPoints": 1521,
	"./historyPoints.js": 1521,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1522,
	"./information/recordTable.js": 1522,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1523,
	"./informationCasino.js": 1523,
	"./informationHipica": 1524,
	"./informationHipica.js": 1524,
	"./informationLiveCasino": 1525,
	"./informationLiveCasino.js": 1525,
	"./informationVirtual": 1526,
	"./informationVirtual.js": 1526,
	"./informeCasino": 1527,
	"./informeCasino.js": 1527,
	"./informeGerencial": 1528,
	"./informeGerencial.js": 1528,
	"./informeGerencial2": 1529,
	"./informeGerencial2.js": 1529,
	"./informeGerencialAgentes2": 1530,
	"./informeGerencialAgentes2.js": 1530,
	"./informeGerencialUsuarios2": 1531,
	"./informeGerencialUsuarios2.js": 1531,
	"./jackpotInternationalReport2": 1532,
	"./jackpotInternationalReport2.js": 1532,
	"./jackpotPaymentReports": 1533,
	"./jackpotPaymentReports.js": 1533,
	"./jackpotPaymentReports2": 1534,
	"./jackpotPaymentReports2.js": 1534,
	"./jackpotPrizeReport": 1535,
	"./jackpotPrizeReport.js": 1535,
	"./jackpotPrizeReportSportBet": 1536,
	"./jackpotPrizeReportSportBet.js": 1536,
	"./jackpotWinnersReport": 1537,
	"./jackpotWinnersReport.js": 1537,
	"./landingReport": 1538,
	"./landingReport.js": 1538,
	"./landingReport2": 1539,
	"./landingReport2.js": 1539,
	"./leagues/AddLeague": 1540,
	"./leagues/AddLeague.js": 1540,
	"./leagues/addLeagueManagement": 1541,
	"./leagues/addLeagueManagement.js": 1541,
	"./leagues/configuration": 1542,
	"./leagues/configuration.js": 1542,
	"./leagues/configuration/changePassword": 1543,
	"./leagues/configuration/changePassword.js": 1543,
	"./leagues/configuration/changePassword/changePasswordView": 1544,
	"./leagues/configuration/changePassword/changePasswordView.js": 1544,
	"./leagues/configuration/generateToken": 1545,
	"./leagues/configuration/generateToken.js": 1545,
	"./leagues/configuration/generateToken/filter": 1546,
	"./leagues/configuration/generateToken/filter.js": 1546,
	"./leagues/configuration/generateToken/table": 1547,
	"./leagues/configuration/generateToken/table.js": 1547,
	"./leagues/configuration/qrgoogle": 1548,
	"./leagues/configuration/qrgoogle.js": 1548,
	"./leagues/configuration/securityChanges": 1549,
	"./leagues/configuration/securityChanges.js": 1549,
	"./leagues/configuration/securityChanges/filter": 1550,
	"./leagues/configuration/securityChanges/filter.js": 1550,
	"./leagues/configuration/securityChanges/table": 1551,
	"./leagues/configuration/securityChanges/table.js": 1551,
	"./leagues/information": 1552,
	"./leagues/information.js": 1552,
	"./leagues/leagues-list/filter": 563,
	"./leagues/leagues-list/filter.js": 563,
	"./leagues/leagues-list/table": 564,
	"./leagues/leagues-list/table.js": 564,
	"./leagues/leaguesList": 1553,
	"./leagues/leaguesList.js": 1553,
	"./leagues/leaguesManagement": 1554,
	"./leagues/leaguesManagement.js": 1554,
	"./leagues/reports": 1555,
	"./leagues/reports.js": 1555,
	"./leagues/reports/betsReport": 1556,
	"./leagues/reports/betsReport.js": 1556,
	"./leagues/reports/betsReport/detailsReport": 1557,
	"./leagues/reports/betsReport/detailsReport.js": 1557,
	"./leagues/reports/betsReport/filterReport": 566,
	"./leagues/reports/betsReport/filterReport.js": 566,
	"./leagues/reports/betsReport/recordReport": 1558,
	"./leagues/reports/betsReport/recordReport.js": 1558,
	"./leagues/reports/betsReport/recordTableReport": 1559,
	"./leagues/reports/betsReport/recordTableReport.js": 1559,
	"./leagues/reports/betsReport/recordTableTransReport": 1560,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1560,
	"./leagues/reports/betsReport/recordTransReport": 568,
	"./leagues/reports/betsReport/recordTransReport.js": 568,
	"./leagues/reports/betsReport/tableReport": 567,
	"./leagues/reports/betsReport/tableReport.js": 567,
	"./leagues/reports/casinoGamesReport": 1561,
	"./leagues/reports/casinoGamesReport.js": 1561,
	"./leagues/reports/casinoReport/detailsCasinoReport": 571,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 571,
	"./leagues/reports/casinoReport/filterCasinoReport": 569,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 569,
	"./leagues/reports/casinoReport/recordCasinoReport": 572,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 572,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1562,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1562,
	"./leagues/reports/casinoReport/tableCasinoReport": 570,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 570,
	"./leagues/reports/userAfilliatesReport": 1563,
	"./leagues/reports/userAfilliatesReport.js": 1563,
	"./leagues/reports/user_affiliates/detailsReports": 1564,
	"./leagues/reports/user_affiliates/detailsReports.js": 1564,
	"./leagues/reports/user_affiliates/filterReports": 573,
	"./leagues/reports/user_affiliates/filterReports.js": 573,
	"./leagues/reports/user_affiliates/recordReports": 1565,
	"./leagues/reports/user_affiliates/recordReports.js": 1565,
	"./leagues/reports/user_affiliates/recordTableReports": 1566,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1566,
	"./leagues/reports/user_affiliates/tableReports": 574,
	"./leagues/reports/user_affiliates/tableReports.js": 574,
	"./leagues/results/recordTableResponts": 565,
	"./leagues/results/recordTableResponts.js": 565,
	"./leagues/results/tableResults": 116,
	"./leagues/results/tableResults.js": 116,
	"./leagues/statistics": 1567,
	"./leagues/statistics.js": 1567,
	"./leagues/statistics/age": 578,
	"./leagues/statistics/age.js": 578,
	"./leagues/statistics/marketing": 576,
	"./leagues/statistics/marketing.js": 576,
	"./leagues/statistics/marketingvsregistros": 577,
	"./leagues/statistics/marketingvsregistros.js": 577,
	"./leagues/statistics/money": 575,
	"./leagues/statistics/money.js": 575,
	"./limitationsReport": 1568,
	"./limitationsReport.js": 1568,
	"./loading": 1569,
	"./loading.js": 1569,
	"./login": 1570,
	"./login.js": 1570,
	"./logsUserGeneral": 1571,
	"./logsUserGeneral.js": 1571,
	"./loteryReport": 1572,
	"./loteryReport.js": 1572,
	"./loyaltyLevelChangeHistory": 1573,
	"./loyaltyLevelChangeHistory.js": 1573,
	"./machine/AddMachineRegister": 1574,
	"./machine/AddMachineRegister.js": 1574,
	"./machine/addMachineManagement": 1575,
	"./machine/addMachineManagement.js": 1575,
	"./machine/cashier/advertising": 588,
	"./machine/cashier/advertising.js": 588,
	"./machine/cashier/cashier": 1576,
	"./machine/cashier/cashier.js": 1576,
	"./machine/cashier/tableAdvertising": 589,
	"./machine/cashier/tableAdvertising.js": 589,
	"./machine/configuration": 1577,
	"./machine/configuration.js": 1577,
	"./machine/configuration/changePassword": 1578,
	"./machine/configuration/changePassword.js": 1578,
	"./machine/configuration/changePassword/changePasswordView": 1579,
	"./machine/configuration/changePassword/changePasswordView.js": 1579,
	"./machine/configuration/generateToken": 1580,
	"./machine/configuration/generateToken.js": 1580,
	"./machine/configuration/generateToken/filter": 1581,
	"./machine/configuration/generateToken/filter.js": 1581,
	"./machine/configuration/generateToken/table": 1582,
	"./machine/configuration/generateToken/table.js": 1582,
	"./machine/configuration/qrgoogle": 1583,
	"./machine/configuration/qrgoogle.js": 1583,
	"./machine/configuration/securityChanges": 1584,
	"./machine/configuration/securityChanges.js": 1584,
	"./machine/configuration/securityChanges/filter": 1023,
	"./machine/configuration/securityChanges/filter.js": 1023,
	"./machine/configuration/securityChanges/table": 590,
	"./machine/configuration/securityChanges/table.js": 590,
	"./machine/filter": 591,
	"./machine/filter.js": 591,
	"./machine/information": 1585,
	"./machine/information.js": 1585,
	"./machine/machineManagement": 1586,
	"./machine/machineManagement.js": 1586,
	"./machine/machineRegister": 1587,
	"./machine/machineRegister.js": 1587,
	"./machine/managePointsGraphics": 1588,
	"./machine/managePointsGraphics.js": 1588,
	"./machine/pagoNotaCobro": 1589,
	"./machine/pagoNotaCobro.js": 1589,
	"./machine/pagoNotaCobro/PagoNotaCobro": 1024,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 1024,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 595,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 595,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 596,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 596,
	"./machine/pagoPremioMaquina": 1590,
	"./machine/pagoPremioMaquina.js": 1590,
	"./machine/pagopremio/PagoPremio": 598,
	"./machine/pagopremio/PagoPremio.js": 598,
	"./machine/pagopremio/detailsPagoPremio": 600,
	"./machine/pagopremio/detailsPagoPremio.js": 600,
	"./machine/pagopremio/filterPagoPremio": 597,
	"./machine/pagopremio/filterPagoPremio.js": 597,
	"./machine/pagopremio/recordPagoPremio": 601,
	"./machine/pagopremio/recordPagoPremio.js": 601,
	"./machine/pagopremio/recordTablePagoPremio": 1591,
	"./machine/pagopremio/recordTablePagoPremio.js": 1591,
	"./machine/pagopremio/tablePagoPremio": 599,
	"./machine/pagopremio/tablePagoPremio.js": 599,
	"./machine/pointsGraphics/filter": 593,
	"./machine/pointsGraphics/filter.js": 593,
	"./machine/pointsGraphics/pointsList": 594,
	"./machine/pointsGraphics/pointsList.js": 594,
	"./machine/products2": 1592,
	"./machine/products2.js": 1592,
	"./machine/products2/categories-products/filter": 602,
	"./machine/products2/categories-products/filter.js": 602,
	"./machine/products2/categories-products/table": 603,
	"./machine/products2/categories-products/table.js": 603,
	"./machine/products2/categoriesProducts": 1593,
	"./machine/products2/categoriesProducts.js": 1593,
	"./machine/products2/partners-games/filter": 604,
	"./machine/products2/partners-games/filter.js": 604,
	"./machine/products2/partners-games/table": 605,
	"./machine/products2/partners-games/table.js": 605,
	"./machine/products2/partners-products/filter": 606,
	"./machine/products2/partners-products/filter.js": 606,
	"./machine/products2/partners-products/table": 607,
	"./machine/products2/partners-products/table.js": 607,
	"./machine/products2/partners-providers/filter": 608,
	"./machine/products2/partners-providers/filter.js": 608,
	"./machine/products2/partners-providers/table": 609,
	"./machine/products2/partners-providers/table.js": 609,
	"./machine/products2/partners-subProviders/filter": 610,
	"./machine/products2/partners-subProviders/filter.js": 610,
	"./machine/products2/partners-subProviders/table": 611,
	"./machine/products2/partners-subProviders/table.js": 611,
	"./machine/products2/partners-tipoproducto/filter": 612,
	"./machine/products2/partners-tipoproducto/filter.js": 612,
	"./machine/products2/partners-tipoproducto/table": 613,
	"./machine/products2/partners-tipoproducto/table.js": 613,
	"./machine/products2/partnersGames": 1594,
	"./machine/products2/partnersGames.js": 1594,
	"./machine/products2/partnersProducts": 1595,
	"./machine/products2/partnersProducts.js": 1595,
	"./machine/products2/partnersProviders": 1596,
	"./machine/products2/partnersProviders.js": 1596,
	"./machine/products2/partnersSubProviders": 1597,
	"./machine/products2/partnersSubProviders.js": 1597,
	"./machine/products2/partnersTypeProduct": 1598,
	"./machine/products2/partnersTypeProduct.js": 1598,
	"./machine/reports": 1599,
	"./machine/reports.js": 1599,
	"./machine/reports/betsReport": 1600,
	"./machine/reports/betsReport.js": 1600,
	"./machine/reports/betsReport/detailsReport": 1601,
	"./machine/reports/betsReport/detailsReport.js": 1601,
	"./machine/reports/betsReport/filterReport": 614,
	"./machine/reports/betsReport/filterReport.js": 614,
	"./machine/reports/betsReport/recordReport": 1602,
	"./machine/reports/betsReport/recordReport.js": 1602,
	"./machine/reports/betsReport/recordTableReport": 1603,
	"./machine/reports/betsReport/recordTableReport.js": 1603,
	"./machine/reports/betsReport/recordTableTransReport": 1604,
	"./machine/reports/betsReport/recordTableTransReport.js": 1604,
	"./machine/reports/betsReport/recordTransReport": 616,
	"./machine/reports/betsReport/recordTransReport.js": 616,
	"./machine/reports/betsReport/tableReport": 615,
	"./machine/reports/betsReport/tableReport.js": 615,
	"./machine/reports/casinoGamesReport": 1605,
	"./machine/reports/casinoGamesReport.js": 1605,
	"./machine/reports/casinoReport/detailsCasinoReport": 619,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 619,
	"./machine/reports/casinoReport/filterCasinoReport": 617,
	"./machine/reports/casinoReport/filterCasinoReport.js": 617,
	"./machine/reports/casinoReport/recordCasinoReport": 620,
	"./machine/reports/casinoReport/recordCasinoReport.js": 620,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1606,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1606,
	"./machine/reports/casinoReport/tableCasinoReport": 618,
	"./machine/reports/casinoReport/tableCasinoReport.js": 618,
	"./machine/reports/depositReport": 1607,
	"./machine/reports/depositReport.js": 1607,
	"./machine/reports/deposit_report/detailsDepositReports": 1025,
	"./machine/reports/deposit_report/detailsDepositReports.js": 1025,
	"./machine/reports/deposit_report/filterDepositReports": 621,
	"./machine/reports/deposit_report/filterDepositReports.js": 621,
	"./machine/reports/deposit_report/recordDepositReports": 623,
	"./machine/reports/deposit_report/recordDepositReports.js": 623,
	"./machine/reports/deposit_report/recordTableDepositReports": 1608,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1608,
	"./machine/reports/deposit_report/tableDepositReports": 622,
	"./machine/reports/deposit_report/tableDepositReports.js": 622,
	"./machine/reports/flujoCaja": 1609,
	"./machine/reports/flujoCaja.js": 1609,
	"./machine/reports/flujocaja/detailsFlujoCaja": 626,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 626,
	"./machine/reports/flujocaja/filterFlujoCaja": 624,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 624,
	"./machine/reports/flujocaja/recordFlujoCaja": 627,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 627,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1610,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1610,
	"./machine/reports/flujocaja/tableFlujoCaja": 625,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 625,
	"./machine/reports/log/log": 628,
	"./machine/reports/log/log.js": 628,
	"./machine/reports/logReport": 1611,
	"./machine/reports/logReport.js": 1611,
	"./machine/reports/updates/filter": 629,
	"./machine/reports/updates/filter.js": 629,
	"./machine/reports/updates/table": 630,
	"./machine/reports/updates/table.js": 630,
	"./machine/reports/updatesReport": 1612,
	"./machine/reports/updatesReport.js": 1612,
	"./machine/reports/userAfilliatesReport": 1613,
	"./machine/reports/userAfilliatesReport.js": 1613,
	"./machine/reports/user_affiliates/detailsReports": 1614,
	"./machine/reports/user_affiliates/detailsReports.js": 1614,
	"./machine/reports/user_affiliates/filterReports": 631,
	"./machine/reports/user_affiliates/filterReports.js": 631,
	"./machine/reports/user_affiliates/recordReports": 1615,
	"./machine/reports/user_affiliates/recordReports.js": 1615,
	"./machine/reports/user_affiliates/recordTableReports": 1616,
	"./machine/reports/user_affiliates/recordTableReports.js": 1616,
	"./machine/reports/user_affiliates/tableReports": 632,
	"./machine/reports/user_affiliates/tableReports.js": 632,
	"./machine/reports/withdrawalRequests": 1617,
	"./machine/reports/withdrawalRequests.js": 1617,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 635,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 635,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 633,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 633,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1618,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1618,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 636,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 636,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 634,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 634,
	"./machine/results/recordTableResponts": 1619,
	"./machine/results/recordTableResponts.js": 1619,
	"./machine/results/tableResults": 1620,
	"./machine/results/tableResults.js": 1620,
	"./machine/statistics": 1621,
	"./machine/statistics.js": 1621,
	"./machine/statistics/age": 640,
	"./machine/statistics/age.js": 640,
	"./machine/statistics/marketing": 638,
	"./machine/statistics/marketing.js": 638,
	"./machine/statistics/marketingvsregistros": 639,
	"./machine/statistics/marketingvsregistros.js": 639,
	"./machine/statistics/money": 637,
	"./machine/statistics/money.js": 637,
	"./machine/table": 592,
	"./machine/table.js": 592,
	"./management/activateRegistration/filter": 203,
	"./management/activateRegistration/filter.js": 203,
	"./management/activateRegistration/response": 204,
	"./management/activateRegistration/response.js": 204,
	"./management/coupons/coupons": 442,
	"./management/coupons/coupons.js": 442,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 505,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 505,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 504,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 504,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 507,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 507,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 506,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 506,
	"./management/faltan.txt": 1951,
	"./management/managementClaims/filter": 641,
	"./management/managementClaims/filter.js": 641,
	"./management/managementClaims/table": 642,
	"./management/managementClaims/table.js": 642,
	"./management/managementContact/details": 162,
	"./management/managementContact/details.js": 162,
	"./management/managementContact/detailsTable": 643,
	"./management/managementContact/detailsTable.js": 643,
	"./management/managementContact/filterManagementContact": 644,
	"./management/managementContact/filterManagementContact.js": 644,
	"./management/managementContact/tableManagementContact": 645,
	"./management/managementContact/tableManagementContact.js": 645,
	"./management/managementContactUser/filter": 646,
	"./management/managementContactUser/filter.js": 646,
	"./management/managementContactUser/table": 647,
	"./management/managementContactUser/table.js": 647,
	"./management/managementGenericForms/filter": 648,
	"./management/managementGenericForms/filter.js": 648,
	"./management/managementGenericForms/table": 649,
	"./management/managementGenericForms/table.js": 649,
	"./management/quotaRetraction/Retraction": 650,
	"./management/quotaRetraction/Retraction.js": 650,
	"./management/quotaRetraction/search": 1026,
	"./management/quotaRetraction/search.js": 1026,
	"./management/registerFast/filterRegisterFast": 651,
	"./management/registerFast/filterRegisterFast.js": 651,
	"./management/registerFast/tableRegisterFast": 652,
	"./management/registerFast/tableRegisterFast.js": 652,
	"./management/reprintCheck/filterReprintCheck": 653,
	"./management/reprintCheck/filterReprintCheck.js": 653,
	"./management/reprintCheck/tableReprintCheck": 654,
	"./management/reprintCheck/tableReprintCheck.js": 654,
	"./management/restrictUser/filter": 655,
	"./management/restrictUser/filter.js": 655,
	"./management/restrictUser/table": 656,
	"./management/restrictUser/table.js": 656,
	"./management/reversionReload/filterReversionReload": 657,
	"./management/reversionReload/filterReversionReload.js": 657,
	"./management/reversionReload/tableReversionReload": 658,
	"./management/reversionReload/tableReversionReload.js": 658,
	"./management/usersVerification/information": 117,
	"./management/usersVerification/information.js": 117,
	"./management/usersVerification/informationJumio": 659,
	"./management/usersVerification/informationJumio.js": 659,
	"./managementClaims": 1622,
	"./managementClaims.js": 1622,
	"./managementContact": 1623,
	"./managementContact.js": 1623,
	"./managementContactUser": 1624,
	"./managementContactUser.js": 1624,
	"./managementGenericForms": 1625,
	"./managementGenericForms.js": 1625,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1626,
	"./menuBonus.js": 1626,
	"./menuBuilder": 1627,
	"./menuBuilder.js": 1627,
	"./menuMarketing": 1628,
	"./menuMarketing.js": 1628,
	"./menus": 1629,
	"./menus.js": 1629,
	"./messages/bannerInvasive": 1630,
	"./messages/bannerInvasive.js": 1630,
	"./messages/bannerInvasive/filter": 662,
	"./messages/bannerInvasive/filter.js": 662,
	"./messages/bannerInvasive/table": 663,
	"./messages/bannerInvasive/table.js": 663,
	"./messages/fringe": 1631,
	"./messages/fringe.js": 1631,
	"./messages/fringe/filter": 664,
	"./messages/fringe/filter.js": 664,
	"./messages/fringe/table": 665,
	"./messages/fringe/table.js": 665,
	"./messages/messageIntern/filter": 118,
	"./messages/messageIntern/filter.js": 118,
	"./messages/messageIntern/table": 119,
	"./messages/messageIntern/table.js": 119,
	"./messages/messageInternAgent/filter": 666,
	"./messages/messageInternAgent/filter.js": 666,
	"./messages/messageInternAgent/table": 667,
	"./messages/messageInternAgent/table.js": 667,
	"./messages/messageInternal": 1632,
	"./messages/messageInternal.js": 1632,
	"./messages/messageInternalAgent": 1633,
	"./messages/messageInternalAgent.js": 1633,
	"./messages/messageList": 1634,
	"./messages/messageList.js": 1634,
	"./messages/popup": 1635,
	"./messages/popup.js": 1635,
	"./messages/popup/filter": 668,
	"./messages/popup/filter.js": 668,
	"./messages/popup/table": 669,
	"./messages/popup/table.js": 669,
	"./messagesOld/messageIntern/filter": 1636,
	"./messagesOld/messageIntern/filter.js": 1636,
	"./messagesOld/messageIntern/table": 1637,
	"./messagesOld/messageIntern/table.js": 1637,
	"./messagesOld/messageList": 1638,
	"./messagesOld/messageList.js": 1638,
	"./myComissionsReport": 1639,
	"./myComissionsReport.js": 1639,
	"./myConfiguration/changeMyPassword": 1640,
	"./myConfiguration/changeMyPassword.js": 1640,
	"./myConfiguration/myInfoBetShop": 1641,
	"./myConfiguration/myInfoBetShop.js": 1641,
	"./myConfiguration/myInfoCustomer": 1642,
	"./myConfiguration/myInfoCustomer.js": 1642,
	"./myConfiguration/myInformation": 1643,
	"./myConfiguration/myInformation.js": 1643,
	"./myConfiguration/qrgoogle": 1644,
	"./myConfiguration/qrgoogle.js": 1644,
	"./notesUser": 1645,
	"./notesUser.js": 1645,
	"./notifications": 997,
	"./notifications.js": 997,
	"./operatorResponsibility": 1646,
	"./operatorResponsibility.js": 1646,
	"./ownersIncome": 1647,
	"./ownersIncome.js": 1647,
	"./ownersIncomeSecondLevel": 1648,
	"./ownersIncomeSecondLevel.js": 1648,
	"./pagoNotaRetiro": 1649,
	"./pagoNotaRetiro.js": 1649,
	"./pagoPremio": 1650,
	"./pagoPremio.js": 1650,
	"./pagoPremioVirtuales": 1651,
	"./pagoPremioVirtuales.js": 1651,
	"./paidPendingAwards": 1652,
	"./paidPendingAwards.js": 1652,
	"./partner/PartnerSettings": 1653,
	"./partner/PartnerSettings.js": 1653,
	"./partner/PartnerSettingsOld": 1654,
	"./partner/PartnerSettingsOld.js": 1654,
	"./partner/TRM": 1655,
	"./partner/TRM.js": 1655,
	"./partner/TRM/filter": 684,
	"./partner/TRM/filter.js": 684,
	"./partner/TRM/table": 685,
	"./partner/TRM/table.js": 685,
	"./partner/configuration": 1656,
	"./partner/configuration.js": 1656,
	"./partner/configuration/filter": 120,
	"./partner/configuration/filter.js": 120,
	"./partner/configuration/settings": 121,
	"./partner/configuration/settings.js": 121,
	"./partner/configurationControl": 1657,
	"./partner/configurationControl.js": 1657,
	"./partner/configurationControl/filter": 686,
	"./partner/configurationControl/filter.js": 686,
	"./partner/configurationControl/table": 687,
	"./partner/configurationControl/table.js": 687,
	"./partner/configurationControl2": 1658,
	"./partner/configurationControl2.js": 1658,
	"./partner/configurationControl2/filter": 688,
	"./partner/configurationControl2/filter.js": 688,
	"./partner/configurationControl2/table": 689,
	"./partner/configurationControl2/table.js": 689,
	"./partner/configurationOld/filter": 1659,
	"./partner/configurationOld/filter.js": 1659,
	"./partner/configurationOld/settings": 1660,
	"./partner/configurationOld/settings.js": 1660,
	"./partner/configurationSEO": 1661,
	"./partner/configurationSEO.js": 1661,
	"./partner/configurationSEO/filter": 690,
	"./partner/configurationSEO/filter.js": 690,
	"./partner/configurationSEO/settings": 691,
	"./partner/configurationSEO/settings.js": 691,
	"./partner/countries": 1662,
	"./partner/countries.js": 1662,
	"./partner/countries/countries": 692,
	"./partner/countries/countries.js": 692,
	"./partner/menusUser": 1663,
	"./partner/menusUser.js": 1663,
	"./partner/menusUser/filter": 693,
	"./partner/menusUser/filter.js": 693,
	"./partner/menusUser/table": 694,
	"./partner/menusUser/table.js": 694,
	"./partner/partner-list/filter": 682,
	"./partner/partner-list/filter.js": 682,
	"./partner/partner-list/table": 683,
	"./partner/partner-list/table.js": 683,
	"./partner/partnertManagement": 1664,
	"./partner/partnertManagement.js": 1664,
	"./partner/products": 1665,
	"./partner/products.js": 1665,
	"./partner/products/categories-products/filter": 695,
	"./partner/products/categories-products/filter.js": 695,
	"./partner/products/categories-products/table": 696,
	"./partner/products/categories-products/table.js": 696,
	"./partner/products/categoriesProducts": 1666,
	"./partner/products/categoriesProducts.js": 1666,
	"./partner/products/partners-products/filter": 697,
	"./partner/products/partners-products/filter.js": 697,
	"./partner/products/partners-products/table": 698,
	"./partner/products/partners-products/table.js": 698,
	"./partner/products/partners-providers/filter": 699,
	"./partner/products/partners-providers/filter.js": 699,
	"./partner/products/partners-providers/table": 700,
	"./partner/products/partners-providers/table.js": 700,
	"./partner/products/partners-subProviders/filter": 701,
	"./partner/products/partners-subProviders/filter.js": 701,
	"./partner/products/partners-subProviders/table": 702,
	"./partner/products/partners-subProviders/table.js": 702,
	"./partner/products/partners-tipoproducto/filter": 703,
	"./partner/products/partners-tipoproducto/filter.js": 703,
	"./partner/products/partners-tipoproducto/table": 704,
	"./partner/products/partners-tipoproducto/table.js": 704,
	"./partner/products/partnersProducts": 1667,
	"./partner/products/partnersProducts.js": 1667,
	"./partner/products/partnersProviders": 1668,
	"./partner/products/partnersProviders.js": 1668,
	"./partner/products/partnersSubProviders": 1669,
	"./partner/products/partnersSubProviders.js": 1669,
	"./partner/products/partnersTypeProduct": 1670,
	"./partner/products/partnersTypeProduct.js": 1670,
	"./partner/products/products-banks/filter": 705,
	"./partner/products/products-banks/filter.js": 705,
	"./partner/products/products-banks/table": 706,
	"./partner/products/products-banks/table.js": 706,
	"./partner/products/products-cryptoNetwork/filter": 707,
	"./partner/products/products-cryptoNetwork/filter.js": 707,
	"./partner/products/products-cryptoNetwork/table": 708,
	"./partner/products/products-cryptoNetwork/table.js": 708,
	"./partner/products/products-franchises/filter": 709,
	"./partner/products/products-franchises/filter.js": 709,
	"./partner/products/products-franchises/table": 710,
	"./partner/products/products-franchises/table.js": 710,
	"./partner/products/productsBanks": 1671,
	"./partner/products/productsBanks.js": 1671,
	"./partner/products/productsCryptoNetwork": 1672,
	"./partner/products/productsCryptoNetwork.js": 1672,
	"./partner/products/productsFranchises": 1673,
	"./partner/products/productsFranchises.js": 1673,
	"./partner/products2": 1674,
	"./partner/products2.js": 1674,
	"./partner/products2/banks-partners/filter": 711,
	"./partner/products2/banks-partners/filter.js": 711,
	"./partner/products2/banks-partners/table": 712,
	"./partner/products2/banks-partners/table.js": 712,
	"./partner/products2/categories-products/filter": 713,
	"./partner/products2/categories-products/filter.js": 713,
	"./partner/products2/categories-products/table": 714,
	"./partner/products2/categories-products/table.js": 714,
	"./partner/products2/categoriesProducts": 1675,
	"./partner/products2/categoriesProducts.js": 1675,
	"./partner/products2/enablement-products/filter": 715,
	"./partner/products2/enablement-products/filter.js": 715,
	"./partner/products2/enablement-products/table": 716,
	"./partner/products2/enablement-products/table.js": 716,
	"./partner/products2/enablementProducts": 1676,
	"./partner/products2/enablementProducts.js": 1676,
	"./partner/products2/franchises-partner/filter": 717,
	"./partner/products2/franchises-partner/filter.js": 717,
	"./partner/products2/franchises-partner/table": 718,
	"./partner/products2/franchises-partner/table.js": 718,
	"./partner/products2/partners-categories/filter": 719,
	"./partner/products2/partners-categories/filter.js": 719,
	"./partner/products2/partners-categories/table": 720,
	"./partner/products2/partners-categories/table.js": 720,
	"./partner/products2/partners-credentialsSubProviders/filter": 721,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 721,
	"./partner/products2/partners-credentialsSubProviders/table": 722,
	"./partner/products2/partners-credentialsSubProviders/table.js": 722,
	"./partner/products2/partners-games/filter": 723,
	"./partner/products2/partners-games/filter.js": 723,
	"./partner/products2/partners-games/table": 724,
	"./partner/products2/partners-games/table.js": 724,
	"./partner/products2/partners-products/filter": 725,
	"./partner/products2/partners-products/filter.js": 725,
	"./partner/products2/partners-products/table": 726,
	"./partner/products2/partners-products/table.js": 726,
	"./partner/products2/partners-providers-order/filter": 1677,
	"./partner/products2/partners-providers-order/filter.js": 1677,
	"./partner/products2/partners-providers-order/table": 1678,
	"./partner/products2/partners-providers-order/table.js": 1678,
	"./partner/products2/partners-providers/filter": 727,
	"./partner/products2/partners-providers/filter.js": 727,
	"./partner/products2/partners-providers/table": 728,
	"./partner/products2/partners-providers/table.js": 728,
	"./partner/products2/partners-subProviders-order/filter": 729,
	"./partner/products2/partners-subProviders-order/filter.js": 729,
	"./partner/products2/partners-subProviders-order/table": 730,
	"./partner/products2/partners-subProviders-order/table.js": 730,
	"./partner/products2/partners-subProviders/filter": 731,
	"./partner/products2/partners-subProviders/filter.js": 731,
	"./partner/products2/partners-subProviders/table": 732,
	"./partner/products2/partners-subProviders/table.js": 732,
	"./partner/products2/partners-tipoproducto/filter": 733,
	"./partner/products2/partners-tipoproducto/filter.js": 733,
	"./partner/products2/partners-tipoproducto/table": 734,
	"./partner/products2/partners-tipoproducto/table.js": 734,
	"./partner/products2/partnersBanks": 1679,
	"./partner/products2/partnersBanks.js": 1679,
	"./partner/products2/partnersCategories": 1680,
	"./partner/products2/partnersCategories.js": 1680,
	"./partner/products2/partnersCredentialsSubProviders": 1681,
	"./partner/products2/partnersCredentialsSubProviders.js": 1681,
	"./partner/products2/partnersFranchises": 1682,
	"./partner/products2/partnersFranchises.js": 1682,
	"./partner/products2/partnersGames": 1683,
	"./partner/products2/partnersGames.js": 1683,
	"./partner/products2/partnersProducts": 1684,
	"./partner/products2/partnersProducts.js": 1684,
	"./partner/products2/partnersProviders": 1685,
	"./partner/products2/partnersProviders.js": 1685,
	"./partner/products2/partnersSubProviders": 1686,
	"./partner/products2/partnersSubProviders.js": 1686,
	"./partner/products2/partnersSubProvidersOrder": 1687,
	"./partner/products2/partnersSubProvidersOrder.js": 1687,
	"./partner/products2/partnersTypeProduct": 1688,
	"./partner/products2/partnersTypeProduct.js": 1688,
	"./partner/reports": 1689,
	"./partner/reports.js": 1689,
	"./partner/reports/autoexclusionUsers": 1690,
	"./partner/reports/autoexclusionUsers.js": 1690,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 737,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 737,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 735,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 735,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 1027,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1027,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 738,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 738,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 736,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 736,
	"./partner/reports/balanceAdjustments": 1691,
	"./partner/reports/balanceAdjustments.js": 1691,
	"./partner/reports/balanceAdjustments/filter": 739,
	"./partner/reports/balanceAdjustments/filter.js": 739,
	"./partner/reports/balanceAdjustments/table": 740,
	"./partner/reports/balanceAdjustments/table.js": 740,
	"./partner/reports/balanceHistory": 1692,
	"./partner/reports/balanceHistory.js": 1692,
	"./partner/reports/balanceHistory/filter": 741,
	"./partner/reports/balanceHistory/filter.js": 741,
	"./partner/reports/balanceHistory/table": 742,
	"./partner/reports/balanceHistory/table.js": 742,
	"./partner/reports/balanceHistoryBetShop": 1693,
	"./partner/reports/balanceHistoryBetShop.js": 1693,
	"./partner/reports/balanceHistoryBetShop/filter": 743,
	"./partner/reports/balanceHistoryBetShop/filter.js": 743,
	"./partner/reports/balanceHistoryBetShop/table": 744,
	"./partner/reports/balanceHistoryBetShop/table.js": 744,
	"./partner/reports/balanceUsers": 1694,
	"./partner/reports/balanceUsers.js": 1694,
	"./partner/reports/balanceUsers/filter": 745,
	"./partner/reports/balanceUsers/filter.js": 745,
	"./partner/reports/balanceUsers/record": 747,
	"./partner/reports/balanceUsers/record.js": 747,
	"./partner/reports/balanceUsers/resume": 748,
	"./partner/reports/balanceUsers/resume.js": 748,
	"./partner/reports/balanceUsers/table": 746,
	"./partner/reports/balanceUsers/table.js": 746,
	"./partner/reports/betsReport": 1695,
	"./partner/reports/betsReport.js": 1695,
	"./partner/reports/betsReport/detailsReport": 1696,
	"./partner/reports/betsReport/detailsReport.js": 1696,
	"./partner/reports/betsReport/filterReport": 749,
	"./partner/reports/betsReport/filterReport.js": 749,
	"./partner/reports/betsReport/recordReport": 753,
	"./partner/reports/betsReport/recordReport.js": 753,
	"./partner/reports/betsReport/recordTableReport": 754,
	"./partner/reports/betsReport/recordTableReport.js": 754,
	"./partner/reports/betsReport/recordTableTransReport": 752,
	"./partner/reports/betsReport/recordTableTransReport.js": 752,
	"./partner/reports/betsReport/recordTransReport": 751,
	"./partner/reports/betsReport/recordTransReport.js": 751,
	"./partner/reports/betsReport/tableReport": 750,
	"./partner/reports/betsReport/tableReport.js": 750,
	"./partner/reports/bonusReport": 1697,
	"./partner/reports/bonusReport.js": 1697,
	"./partner/reports/bonusReport/detailsBonusReport": 757,
	"./partner/reports/bonusReport/detailsBonusReport.js": 757,
	"./partner/reports/bonusReport/filterBonusReport": 755,
	"./partner/reports/bonusReport/filterBonusReport.js": 755,
	"./partner/reports/bonusReport/recordBonusReport": 758,
	"./partner/reports/bonusReport/recordBonusReport.js": 758,
	"./partner/reports/bonusReport/recordTableBonusReport": 759,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 759,
	"./partner/reports/bonusReport/tableBonusReport": 756,
	"./partner/reports/bonusReport/tableBonusReport.js": 756,
	"./partner/reports/casinoGamesReport": 1698,
	"./partner/reports/casinoGamesReport.js": 1698,
	"./partner/reports/casinoReport/detailsCasinoReport": 762,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 762,
	"./partner/reports/casinoReport/filterCasinoReport": 760,
	"./partner/reports/casinoReport/filterCasinoReport.js": 760,
	"./partner/reports/casinoReport/recordCasinoReport": 763,
	"./partner/reports/casinoReport/recordCasinoReport.js": 763,
	"./partner/reports/casinoReport/recordTableCasinoReport": 764,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 764,
	"./partner/reports/casinoReport/tableCasinoReport": 761,
	"./partner/reports/casinoReport/tableCasinoReport.js": 761,
	"./partner/reports/comissionsReport": 1699,
	"./partner/reports/comissionsReport.js": 1699,
	"./partner/reports/comissions_report/filter": 765,
	"./partner/reports/comissions_report/filter.js": 765,
	"./partner/reports/comissions_report/table": 766,
	"./partner/reports/comissions_report/table.js": 766,
	"./partner/reports/depositReport": 1700,
	"./partner/reports/depositReport.js": 1700,
	"./partner/reports/deposit_report/detailsDepositReports": 1028,
	"./partner/reports/deposit_report/detailsDepositReports.js": 1028,
	"./partner/reports/deposit_report/filterDepositReports": 767,
	"./partner/reports/deposit_report/filterDepositReports.js": 767,
	"./partner/reports/deposit_report/recordDepositReports": 769,
	"./partner/reports/deposit_report/recordDepositReports.js": 769,
	"./partner/reports/deposit_report/recordTableDepositReports": 770,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 770,
	"./partner/reports/deposit_report/tableDepositReports": 768,
	"./partner/reports/deposit_report/tableDepositReports.js": 768,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 771,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 771,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 772,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 772,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 773,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 773,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 122,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 122,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 774,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 774,
	"./partner/reports/historicalCashFlow": 1701,
	"./partner/reports/historicalCashFlow.js": 1701,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 777,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 777,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 775,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 775,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 778,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 778,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 779,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 779,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 776,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 776,
	"./partner/reports/historyMovement": 1702,
	"./partner/reports/historyMovement.js": 1702,
	"./partner/reports/historyMovement/filter": 780,
	"./partner/reports/historyMovement/filter.js": 780,
	"./partner/reports/historyMovement/table": 781,
	"./partner/reports/historyMovement/table.js": 781,
	"./partner/reports/informeCasino/detailsInformeCasino": 1703,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1703,
	"./partner/reports/informeCasino/filterInformeCasino": 1704,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1704,
	"./partner/reports/informeCasino/recordInformeCasino": 1705,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1705,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1706,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1706,
	"./partner/reports/informeCasino/tableInformeCasino": 1707,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1707,
	"./partner/reports/informeGerencial": 1708,
	"./partner/reports/informeGerencial.js": 1708,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 784,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 784,
	"./partner/reports/informeGerencial/filterInformeGerencial": 782,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 782,
	"./partner/reports/informeGerencial/recordInformeGerencial": 785,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 785,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 786,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 786,
	"./partner/reports/informeGerencial/tableInformeGerencial": 783,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 783,
	"./partner/reports/landingReport/detailsLandingReport": 1709,
	"./partner/reports/landingReport/detailsLandingReport.js": 1709,
	"./partner/reports/landingReport/filterLandingReport": 1710,
	"./partner/reports/landingReport/filterLandingReport.js": 1710,
	"./partner/reports/landingReport/recordLandingReport": 1711,
	"./partner/reports/landingReport/recordLandingReport.js": 1711,
	"./partner/reports/landingReport/recordTableLandingReport": 1712,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1712,
	"./partner/reports/landingReport/tableLandingReport": 1713,
	"./partner/reports/landingReport/tableLandingReport.js": 1713,
	"./partner/reports/logsUser/filter": 1714,
	"./partner/reports/logsUser/filter.js": 1714,
	"./partner/reports/logsUser/table": 1715,
	"./partner/reports/logsUser/table.js": 1715,
	"./partner/reports/operatorResponsibility/filter": 1716,
	"./partner/reports/operatorResponsibility/filter.js": 1716,
	"./partner/reports/operatorResponsibility/table": 1717,
	"./partner/reports/operatorResponsibility/table.js": 1717,
	"./partner/reports/paidPendingAwards": 1718,
	"./partner/reports/paidPendingAwards.js": 1718,
	"./partner/reports/playersReport/detailsPlayersReport": 1719,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1719,
	"./partner/reports/playersReport/filterPlayersReport": 1720,
	"./partner/reports/playersReport/filterPlayersReport.js": 1720,
	"./partner/reports/playersReport/recordPlayersReport": 1721,
	"./partner/reports/playersReport/recordPlayersReport.js": 1721,
	"./partner/reports/playersReport/recordTablePlayersReport": 790,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 790,
	"./partner/reports/playersReport/tablePlayersReport": 1722,
	"./partner/reports/playersReport/tablePlayersReport.js": 1722,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1029,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1029,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 787,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 787,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1030,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1030,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 789,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 789,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 788,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 788,
	"./partner/reports/promotionalCodes/filter": 1723,
	"./partner/reports/promotionalCodes/filter.js": 1723,
	"./partner/reports/promotionalCodes/table": 1724,
	"./partner/reports/promotionalCodes/table.js": 1724,
	"./partner/reports/quotaRetraction/filter": 1725,
	"./partner/reports/quotaRetraction/filter.js": 1725,
	"./partner/reports/quotaRetraction/table": 1726,
	"./partner/reports/quotaRetraction/table.js": 1726,
	"./partner/reports/registeredDocument": 1727,
	"./partner/reports/registeredDocument.js": 1727,
	"./partner/reports/registeredDocuments/filter": 791,
	"./partner/reports/registeredDocuments/filter.js": 791,
	"./partner/reports/registeredDocuments/table": 792,
	"./partner/reports/registeredDocuments/table.js": 792,
	"./partner/reports/relationUserAggregator": 1728,
	"./partner/reports/relationUserAggregator.js": 1728,
	"./partner/reports/relationUserAggregator/filter": 793,
	"./partner/reports/relationUserAggregator/filter.js": 793,
	"./partner/reports/relationUserAggregator/table": 794,
	"./partner/reports/relationUserAggregator/table.js": 794,
	"./partner/reports/reportHash/filter": 1729,
	"./partner/reports/reportHash/filter.js": 1729,
	"./partner/reports/reportHash/table": 1730,
	"./partner/reports/reportHash/table.js": 1730,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1731,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1731,
	"./partner/reports/sessionsReport/filterSessionsReport": 1732,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1732,
	"./partner/reports/sessionsReport/recordSessionsReport": 1733,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1733,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1031,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1031,
	"./partner/reports/sessionsReport/tableSessionsReport": 1734,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1734,
	"./partner/reports/sportsTransactions": 1735,
	"./partner/reports/sportsTransactions.js": 1735,
	"./partner/reports/sportsTransactions/filter": 795,
	"./partner/reports/sportsTransactions/filter.js": 795,
	"./partner/reports/sportsTransactions/table": 796,
	"./partner/reports/sportsTransactions/table.js": 796,
	"./partner/reports/summaryCashFlow": 1736,
	"./partner/reports/summaryCashFlow.js": 1736,
	"./partner/reports/taxableEarnings/filter": 1737,
	"./partner/reports/taxableEarnings/filter.js": 1737,
	"./partner/reports/taxableEarnings/table": 1738,
	"./partner/reports/taxableEarnings/table.js": 1738,
	"./partner/reports/transfersReport/filter": 1739,
	"./partner/reports/transfersReport/filter.js": 1739,
	"./partner/reports/transfersReport/table": 1740,
	"./partner/reports/transfersReport/table.js": 1740,
	"./partner/reports/usuarioOnlineResumido": 1741,
	"./partner/reports/usuarioOnlineResumido.js": 1741,
	"./partner/reports/usuarioOnlineResumido/filter": 797,
	"./partner/reports/usuarioOnlineResumido/filter.js": 797,
	"./partner/reports/usuarioOnlineResumido/table": 798,
	"./partner/reports/usuarioOnlineResumido/table.js": 798,
	"./partner/reports/wallets": 1742,
	"./partner/reports/wallets.js": 1742,
	"./partner/reports/wallets/filter": 799,
	"./partner/reports/wallets/filter.js": 799,
	"./partner/reports/wallets/table": 800,
	"./partner/reports/wallets/table.js": 800,
	"./partner/templates": 1743,
	"./partner/templates.js": 1743,
	"./partner/templates/email": 1744,
	"./partner/templates/email.js": 1744,
	"./partner/templates/email/filter": 801,
	"./partner/templates/email/filter.js": 801,
	"./partner/templates/email/table": 802,
	"./partner/templates/email/table.js": 802,
	"./partner/templates/email/template": 803,
	"./partner/templates/email/template.js": 803,
	"./partner/templates/emailTemplate": 1745,
	"./partner/templates/emailTemplate.js": 1745,
	"./partner/templates/pdf": 1746,
	"./partner/templates/pdf.js": 1746,
	"./partner/templates/pdf/filter": 804,
	"./partner/templates/pdf/filter.js": 804,
	"./partner/templates/pdf/table": 805,
	"./partner/templates/pdf/table.js": 805,
	"./partner/templates/pdf/template": 806,
	"./partner/templates/pdf/template.js": 806,
	"./partner/templates/pdfTemplate": 1747,
	"./partner/templates/pdfTemplate.js": 1747,
	"./partner/templates/sms": 1748,
	"./partner/templates/sms.js": 1748,
	"./partner/templates/sms/filter": 807,
	"./partner/templates/sms/filter.js": 807,
	"./partner/templates/sms/table": 808,
	"./partner/templates/sms/table.js": 808,
	"./partner/templates/sms/template": 809,
	"./partner/templates/sms/template.js": 809,
	"./partner/templates/smsTemplate": 1749,
	"./partner/templates/smsTemplate.js": 1749,
	"./partners": 1750,
	"./partners.js": 1750,
	"./partnersCategories": 1751,
	"./partnersCategories.js": 1751,
	"./partnersProducts": 1752,
	"./partnersProducts.js": 1752,
	"./partnersProductsCountry": 1753,
	"./partnersProductsCountry.js": 1753,
	"./partnersProviders": 1754,
	"./partnersProviders.js": 1754,
	"./partnersTypeProduct": 1755,
	"./partnersTypeProduct.js": 1755,
	"./payPrizesLoyalty": 1756,
	"./payPrizesLoyalty.js": 1756,
	"./payhistoryview": 1757,
	"./payhistoryview.js": 1757,
	"./platformSpecific": 1758,
	"./platformSpecific.js": 1758,
	"./platformSpecific2": 1759,
	"./platformSpecific2.js": 1759,
	"./playerAccount": 1760,
	"./playerAccount.js": 1760,
	"./playerAccount2": 1761,
	"./playerAccount2.js": 1761,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1762,
	"./playersList.js": 1762,
	"./playersList2": 1763,
	"./playersList2.js": 1763,
	"./playersListAggregator": 1764,
	"./playersListAggregator.js": 1764,
	"./playersLists": 1765,
	"./playersLists.js": 1765,
	"./playersReport": 1766,
	"./playersReport.js": 1766,
	"./pointSettings": 1767,
	"./pointSettings.js": 1767,
	"./pointsUsers": 1768,
	"./pointsUsers.js": 1768,
	"./pokerReport": 1769,
	"./pokerReport.js": 1769,
	"./prices": 1770,
	"./prices.js": 1770,
	"./prizesLoyalty": 1771,
	"./prizesLoyalty.js": 1771,
	"./products": 1772,
	"./products.js": 1772,
	"./products/activeProviders/filterActiveProviders": 205,
	"./products/activeProviders/filterActiveProviders.js": 205,
	"./products/activeProviders/tableActiveProviders": 206,
	"./products/activeProviders/tableActiveProviders.js": 206,
	"./products/banks/filterBanks": 323,
	"./products/banks/filterBanks.js": 323,
	"./products/banks/tableBanks": 324,
	"./products/banks/tableBanks.js": 324,
	"./products/blockchain-networks/filterBlockchainNetworks": 380,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 380,
	"./products/blockchain-networks/tableBlockchainNetworks": 381,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 381,
	"./products/categories-products/detailsCategoriesProducts": 1014,
	"./products/categories-products/detailsCategoriesProducts.js": 1014,
	"./products/categories-products/filterCategoriesProducts": 423,
	"./products/categories-products/filterCategoriesProducts.js": 423,
	"./products/categories-products/recordCategoriesProducts": 1015,
	"./products/categories-products/recordCategoriesProducts.js": 1015,
	"./products/categories-products/recordTableCategoriesProducts": 425,
	"./products/categories-products/recordTableCategoriesProducts.js": 425,
	"./products/categories-products/tableCategoriesProducts": 424,
	"./products/categories-products/tableCategoriesProducts.js": 424,
	"./products/categories/detailsCategories": 1012,
	"./products/categories/detailsCategories.js": 1012,
	"./products/categories/filterCategories": 420,
	"./products/categories/filterCategories.js": 420,
	"./products/categories/recordCategories": 1013,
	"./products/categories/recordCategories.js": 1013,
	"./products/categories/recordTableCategories": 422,
	"./products/categories/recordTableCategories.js": 422,
	"./products/categories/tableCategories": 421,
	"./products/categories/tableCategories.js": 421,
	"./products/crypto-blockchain/filterCryptoBlockchain": 445,
	"./products/crypto-blockchain/filterCryptoBlockchain.js": 445,
	"./products/crypto-blockchain/tableCryptoBlockchain": 446,
	"./products/crypto-blockchain/tableCryptoBlockchain.js": 446,
	"./products/cryptos/filterCrypto": 447,
	"./products/cryptos/filterCrypto.js": 447,
	"./products/cryptos/tableCrypto": 448,
	"./products/cryptos/tableCrypto.js": 448,
	"./products/franchises/filterFranchises": 514,
	"./products/franchises/filterFranchises.js": 514,
	"./products/franchises/tableFranchises": 515,
	"./products/franchises/tableFranchises.js": 515,
	"./products/partners-products-country/detailsPartnersProductsCountry": 820,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 820,
	"./products/partners-products-country/filterPartnersProductsCountry": 818,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 818,
	"./products/partners-products-country/recordPartnersProductsCountry": 821,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 821,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 822,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 822,
	"./products/partners-products-country/tablePartnersProductsCountry": 819,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 819,
	"./products/partners-products/detailsPartnersProducts": 816,
	"./products/partners-products/detailsPartnersProducts.js": 816,
	"./products/partners-products/filterPartnersProducts": 814,
	"./products/partners-products/filterPartnersProducts.js": 814,
	"./products/partners-products/recordPartnersProducts": 817,
	"./products/partners-products/recordPartnersProducts.js": 817,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 815,
	"./products/partners-products/tablePartnersProducts.js": 815,
	"./products/partners-providers/details": 825,
	"./products/partners-providers/details.js": 825,
	"./products/partners-providers/filter": 823,
	"./products/partners-providers/filter.js": 823,
	"./products/partners-providers/record": 826,
	"./products/partners-providers/record.js": 826,
	"./products/partners-providers/recordTable": 1773,
	"./products/partners-providers/recordTable.js": 1773,
	"./products/partners-providers/table": 824,
	"./products/partners-providers/table.js": 824,
	"./products/partners-tipoproducto/details": 829,
	"./products/partners-tipoproducto/details.js": 829,
	"./products/partners-tipoproducto/filter": 827,
	"./products/partners-tipoproducto/filter.js": 827,
	"./products/partners-tipoproducto/record": 830,
	"./products/partners-tipoproducto/record.js": 830,
	"./products/partners-tipoproducto/recordTable": 1774,
	"./products/partners-tipoproducto/recordTable.js": 1774,
	"./products/partners-tipoproducto/table": 828,
	"./products/partners-tipoproducto/table.js": 828,
	"./products/partners/filter": 810,
	"./products/partners/filter.js": 810,
	"./products/partners/table": 811,
	"./products/partners/table.js": 811,
	"./products/products/detailsProducts": 1032,
	"./products/products/detailsProducts.js": 1032,
	"./products/products/filterProducts": 852,
	"./products/products/filterProducts.js": 852,
	"./products/products/recordProducts": 1033,
	"./products/products/recordProducts.js": 1033,
	"./products/products/recordTableProducts": 854,
	"./products/products/recordTableProducts.js": 854,
	"./products/products/tableProducts": 853,
	"./products/products/tableProducts.js": 853,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 855,
	"./products/providers/filterProviders.js": 855,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 325,
	"./products/providers/recordTableProviders.js": 325,
	"./products/providers/tableProviders": 856,
	"./products/providers/tableProviders.js": 856,
	"./products/subProviders/filter": 857,
	"./products/subProviders/filter.js": 857,
	"./products/subProviders/table": 858,
	"./products/subProviders/table.js": 858,
	"./products/tags/detailsTags": 1034,
	"./products/tags/detailsTags.js": 1034,
	"./products/tags/filterTags": 859,
	"./products/tags/filterTags.js": 859,
	"./products/tags/recordTableTags": 860,
	"./products/tags/recordTableTags.js": 860,
	"./products/tags/recordTags": 1035,
	"./products/tags/recordTags.js": 1035,
	"./products/tags/tableTags": 861,
	"./products/tags/tableTags.js": 861,
	"./profile": 1775,
	"./profile.js": 1775,
	"./profileOptions": 1776,
	"./profileOptions.js": 1776,
	"./profileOptions2": 1777,
	"./profileOptions2.js": 1777,
	"./profileOptionsOld": 1778,
	"./profileOptionsOld.js": 1778,
	"./promotionalCasinoCampaings": 1779,
	"./promotionalCasinoCampaings.js": 1779,
	"./promotionalCodes": 1780,
	"./promotionalCodes.js": 1780,
	"./promotionalSportbookCampaings": 1781,
	"./promotionalSportbookCampaings.js": 1781,
	"./providers": 1782,
	"./providers.js": 1782,
	"./qualifying": 1783,
	"./qualifying.js": 1783,
	"./quotaRetraction": 1784,
	"./quotaRetraction.js": 1784,
	"./quotaRetractionReport": 1785,
	"./quotaRetractionReport.js": 1785,
	"./recargarCredito": 1786,
	"./recargarCredito.js": 1786,
	"./recargarCreditoAgente": 1787,
	"./recargarCreditoAgente.js": 1787,
	"./referralsAwardsReport": 1788,
	"./referralsAwardsReport.js": 1788,
	"./referralsReport": 1789,
	"./referralsReport.js": 1789,
	"./registerFast": 1790,
	"./registerFast.js": 1790,
	"./registeredDocument": 1791,
	"./registeredDocument.js": 1791,
	"./registeredDocuments": 1792,
	"./registeredDocuments.js": 1792,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 434,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 434,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 435,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 435,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 436,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 436,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 437,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 437,
	"./regulations/futureEvents/filterFutureEventsReports": 516,
	"./regulations/futureEvents/filterFutureEventsReports.js": 516,
	"./regulations/futureEvents/tableFutureEventsReports": 517,
	"./regulations/futureEvents/tableFutureEventsReports.js": 517,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 518,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 518,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 519,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 519,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 520,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 520,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 521,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 521,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 547,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 547,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 548,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 548,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 549,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 549,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 550,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 550,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 551,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 551,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 552,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 552,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 553,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 553,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 554,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 554,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 676,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 676,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 677,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 677,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 678,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 678,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 679,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 679,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 831,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 831,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 832,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 832,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 833,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 833,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 834,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 834,
	"./regulations/playerAccount/filterPlayerAccountReports": 835,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 835,
	"./regulations/playerAccount/tablePlayerAccountReports": 836,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 836,
	"./regulations/playerAccount2/filterPlayerAccountReports": 837,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 837,
	"./regulations/playerAccount2/tablePlayerAccountReports": 838,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 838,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 886,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 886,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 887,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 887,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 888,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 888,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 889,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 889,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 890,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 890,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 891,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 891,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 892,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 892,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 893,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 893,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 894,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 894,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 895,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 895,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 896,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 896,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 897,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 897,
	"./relationUserAggregator": 1793,
	"./relationUserAggregator.js": 1793,
	"./reportHash": 1794,
	"./reportHash.js": 1794,
	"./reportMarketing": 1795,
	"./reportMarketing.js": 1795,
	"./reports/affiliatesBetShop/filter": 209,
	"./reports/affiliatesBetShop/filter.js": 209,
	"./reports/affiliatesBetShop/table": 210,
	"./reports/affiliatesBetShop/table.js": 210,
	"./reports/assignmentQuota/filter": 294,
	"./reports/assignmentQuota/filter.js": 294,
	"./reports/assignmentQuota/table": 295,
	"./reports/assignmentQuota/table.js": 295,
	"./reports/assignmentQuotaMade/filter": 292,
	"./reports/assignmentQuotaMade/filter.js": 292,
	"./reports/assignmentQuotaMade/table": 293,
	"./reports/assignmentQuotaMade/table.js": 293,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 298,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 298,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 296,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 296,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 299,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 299,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 297,
	"./reports/balanceAdjustments/filter": 300,
	"./reports/balanceAdjustments/filter.js": 300,
	"./reports/balanceAdjustments/table": 301,
	"./reports/balanceAdjustments/table.js": 301,
	"./reports/balanceHistory/filter": 302,
	"./reports/balanceHistory/filter.js": 302,
	"./reports/balanceHistory/table": 303,
	"./reports/balanceHistory/table.js": 303,
	"./reports/balanceHistory2/filter": 1796,
	"./reports/balanceHistory2/filter.js": 1796,
	"./reports/balanceHistory2/filter2": 304,
	"./reports/balanceHistory2/filter2.js": 304,
	"./reports/balanceHistory2/table": 1797,
	"./reports/balanceHistory2/table.js": 1797,
	"./reports/balanceHistory2/table2": 305,
	"./reports/balanceHistory2/table2.js": 305,
	"./reports/balanceHistoryBetShop/filter": 308,
	"./reports/balanceHistoryBetShop/filter.js": 308,
	"./reports/balanceHistoryBetShop/table": 309,
	"./reports/balanceHistoryBetShop/table.js": 309,
	"./reports/balanceHistoryBetShop2/filter": 1798,
	"./reports/balanceHistoryBetShop2/filter.js": 1798,
	"./reports/balanceHistoryBetShop2/filter2": 310,
	"./reports/balanceHistoryBetShop2/filter2.js": 310,
	"./reports/balanceHistoryBetShop2/table": 1799,
	"./reports/balanceHistoryBetShop2/table.js": 1799,
	"./reports/balanceHistoryBetShop2/table2": 311,
	"./reports/balanceHistoryBetShop2/table2.js": 311,
	"./reports/balanceHistoryForAdminUser/filter": 306,
	"./reports/balanceHistoryForAdminUser/filter.js": 306,
	"./reports/balanceHistoryForAdminUser/table": 307,
	"./reports/balanceHistoryForAdminUser/table.js": 307,
	"./reports/balanceHistoryForAgent/filter": 312,
	"./reports/balanceHistoryForAgent/filter.js": 312,
	"./reports/balanceHistoryForAgent/table": 313,
	"./reports/balanceHistoryForAgent/table.js": 313,
	"./reports/balanceHistoryForBetShop/filter": 314,
	"./reports/balanceHistoryForBetShop/filter.js": 314,
	"./reports/balanceHistoryForBetShop/table": 315,
	"./reports/balanceHistoryForBetShop/table.js": 315,
	"./reports/balanceHistoryMachine/filter": 316,
	"./reports/balanceHistoryMachine/filter.js": 316,
	"./reports/balanceHistoryMachine/table": 317,
	"./reports/balanceHistoryMachine/table.js": 317,
	"./reports/balanceUsers/filter": 318,
	"./reports/balanceUsers/filter.js": 318,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 320,
	"./reports/balanceUsers/resume.js": 320,
	"./reports/balanceUsers/table": 319,
	"./reports/balanceUsers/table.js": 319,
	"./reports/betsReport/detailsReport": 1800,
	"./reports/betsReport/detailsReport.js": 1800,
	"./reports/betsReport/filterReport": 92,
	"./reports/betsReport/filterReport.js": 92,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 94,
	"./reports/betsReport/recordTransReport.js": 94,
	"./reports/betsReport/tableReport": 93,
	"./reports/betsReport/tableReport.js": 93,
	"./reports/betsReportBetShop/detailsReport": 1801,
	"./reports/betsReportBetShop/detailsReport.js": 1801,
	"./reports/betsReportBetShop/filterReport": 374,
	"./reports/betsReportBetShop/filterReport.js": 374,
	"./reports/betsReportBetShop/recordReport": 377,
	"./reports/betsReportBetShop/recordReport.js": 377,
	"./reports/betsReportBetShop/recordTableReport": 1802,
	"./reports/betsReportBetShop/recordTableReport.js": 1802,
	"./reports/betsReportBetShop/recordTableTransReport": 1803,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1803,
	"./reports/betsReportBetShop/recordTransReport": 376,
	"./reports/betsReportBetShop/recordTransReport.js": 376,
	"./reports/betsReportBetShop/tableReport": 375,
	"./reports/betsReportBetShop/tableReport.js": 375,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 382,
	"./reports/bonusReport/filterBonusReport.js": 382,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 383,
	"./reports/bonusReport/tableBonusReport.js": 383,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 384,
	"./reports/bonusReport2/filterBonusReport.js": 384,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1804,
	"./reports/bonusReport2/recordTableBonusReport.js": 1804,
	"./reports/bonusReport2/tableBonusReport": 385,
	"./reports/bonusReport2/tableBonusReport.js": 385,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 416,
	"./reports/casinoReport/filterCasinoReport.js": 416,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 417,
	"./reports/casinoReport/tableCasinoReport.js": 417,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1805,
	"./reports/casinoReport2/filterCasinoReport.js": 1805,
	"./reports/casinoReport2/filterCasinoReport2": 418,
	"./reports/casinoReport2/filterCasinoReport2.js": 418,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1806,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1806,
	"./reports/casinoReport2/tableCasinoReport": 1807,
	"./reports/casinoReport2/tableCasinoReport.js": 1807,
	"./reports/casinoReport2/tableCasinoReport2": 419,
	"./reports/casinoReport2/tableCasinoReport2.js": 419,
	"./reports/comissions_report/filter": 426,
	"./reports/comissions_report/filter.js": 426,
	"./reports/comissions_report/table": 427,
	"./reports/comissions_report/table.js": 427,
	"./reports/comissions_report2/filter": 428,
	"./reports/comissions_report2/filter.js": 428,
	"./reports/comissions_report2/table": 429,
	"./reports/comissions_report2/table.js": 429,
	"./reports/commisionsPay/filter": 430,
	"./reports/commisionsPay/filter.js": 430,
	"./reports/commisionsPay/table": 431,
	"./reports/commisionsPay/table.js": 431,
	"./reports/coupons_report/details": 1808,
	"./reports/coupons_report/details.js": 1808,
	"./reports/coupons_report/filter": 443,
	"./reports/coupons_report/filter.js": 443,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1809,
	"./reports/coupons_report/recordReports.js": 1809,
	"./reports/coupons_report/table": 444,
	"./reports/coupons_report/table.js": 444,
	"./reports/customReport/filter": 449,
	"./reports/customReport/filter.js": 449,
	"./reports/customReport/table": 450,
	"./reports/customReport/table.js": 450,
	"./reports/depositReport2/filter": 495,
	"./reports/depositReport2/filter.js": 495,
	"./reports/depositReport2/table": 496,
	"./reports/depositReport2/table.js": 496,
	"./reports/deposit_report/detailsDepositReports": 1020,
	"./reports/deposit_report/detailsDepositReports.js": 1020,
	"./reports/deposit_report/filterDepositReports": 493,
	"./reports/deposit_report/filterDepositReports.js": 493,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 494,
	"./reports/deposit_report/tableDepositReports.js": 494,
	"./reports/deposit_report_3/detailsDepositReports": 1021,
	"./reports/deposit_report_3/detailsDepositReports.js": 1021,
	"./reports/deposit_report_3/filterDepositReports": 497,
	"./reports/deposit_report_3/filterDepositReports.js": 497,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1810,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1810,
	"./reports/deposit_report_3/tableDepositReports": 498,
	"./reports/deposit_report_3/tableDepositReports.js": 498,
	"./reports/deposit_report_betshop/detailsDepositReports": 1022,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 1022,
	"./reports/deposit_report_betshop/filterDepositReports": 499,
	"./reports/deposit_report_betshop/filterDepositReports.js": 499,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1811,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1811,
	"./reports/deposit_report_betshop/tableDepositReports": 500,
	"./reports/deposit_report_betshop/tableDepositReports.js": 500,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 508,
	"./reports/emailsReport/filterEmailsReport.js": 508,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1812,
	"./reports/emailsReport/recordTableEmailsReport.js": 1812,
	"./reports/emailsReport/tableEmailsReport": 509,
	"./reports/emailsReport/tableEmailsReport.js": 509,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 904,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 904,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 905,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 905,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 906,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 906,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 907,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 907,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 908,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 908,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1813,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1813,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 909,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 909,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 910,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 910,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1814,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1814,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1815,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1815,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 911,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 911,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 912,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 912,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 913,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 913,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 914,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 914,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1816,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1816,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 915,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 915,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 524,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 524,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 522,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 522,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 525,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 525,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 526,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 526,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 523,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 523,
	"./reports/historyMovement/filter": 527,
	"./reports/historyMovement/filter.js": 527,
	"./reports/historyMovement/table": 528,
	"./reports/historyMovement/table.js": 528,
	"./reports/historyMovementBetShop/filter": 529,
	"./reports/historyMovementBetShop/filter.js": 529,
	"./reports/historyMovementBetShop/table": 530,
	"./reports/historyMovementBetShop/table.js": 530,
	"./reports/historyPoints/filter": 531,
	"./reports/historyPoints/filter.js": 531,
	"./reports/historyPoints/table": 532,
	"./reports/historyPoints/table.js": 532,
	"./reports/informeCasino/detailsInformeCasino": 535,
	"./reports/informeCasino/detailsInformeCasino.js": 535,
	"./reports/informeCasino/filterInformeCasino": 533,
	"./reports/informeCasino/filterInformeCasino.js": 533,
	"./reports/informeCasino/recordInformeCasino": 536,
	"./reports/informeCasino/recordInformeCasino.js": 536,
	"./reports/informeCasino/recordTableInformeCasino": 1817,
	"./reports/informeCasino/recordTableInformeCasino.js": 1817,
	"./reports/informeCasino/tableInformeCasino": 534,
	"./reports/informeCasino/tableInformeCasino.js": 534,
	"./reports/informeGerencial/detailsInformeGerencial": 1818,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1818,
	"./reports/informeGerencial/filterInformeGerencial": 537,
	"./reports/informeGerencial/filterInformeGerencial.js": 537,
	"./reports/informeGerencial/recordInformeGerencial": 1819,
	"./reports/informeGerencial/recordInformeGerencial.js": 1819,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 538,
	"./reports/informeGerencial/tableInformeGerencial.js": 538,
	"./reports/informeGerencial2/detailsInformeGerencial": 1820,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1820,
	"./reports/informeGerencial2/filterInformeGerencial": 1821,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1821,
	"./reports/informeGerencial2/filterInformeGerencial2": 539,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 539,
	"./reports/informeGerencial2/recordInformeGerencial": 1822,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1822,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1823,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1823,
	"./reports/informeGerencial2/tableInformeGerencial": 1824,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1824,
	"./reports/informeGerencial2/tableInformeGerencial2": 540,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 540,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1825,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1825,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1826,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1826,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 541,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 541,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1827,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1827,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1828,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1828,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1829,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1829,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 542,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 542,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1830,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1830,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1831,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1831,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 543,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 543,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1832,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1832,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1833,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1833,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1834,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1834,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 544,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 544,
	"./reports/jackpotInternationalReport/filter": 545,
	"./reports/jackpotInternationalReport/filter.js": 545,
	"./reports/jackpotInternationalReport/table": 546,
	"./reports/jackpotInternationalReport/table.js": 546,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 555,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 555,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1835,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1835,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1836,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1836,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 556,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 556,
	"./reports/landingReport/detailsLandingReport": 559,
	"./reports/landingReport/detailsLandingReport.js": 559,
	"./reports/landingReport/filterLandingReport": 557,
	"./reports/landingReport/filterLandingReport.js": 557,
	"./reports/landingReport/recordLandingReport": 560,
	"./reports/landingReport/recordLandingReport.js": 560,
	"./reports/landingReport/recordTableLandingReport": 1837,
	"./reports/landingReport/recordTableLandingReport.js": 1837,
	"./reports/landingReport/tableLandingReport": 558,
	"./reports/landingReport/tableLandingReport.js": 558,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 561,
	"./reports/landingReport2/filterLandingReport.js": 561,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1838,
	"./reports/landingReport2/recordTableLandingReport.js": 1838,
	"./reports/landingReport2/tableLandingReport": 562,
	"./reports/landingReport2/tableLandingReport.js": 562,
	"./reports/limitationsReport/filterDepositReports": 579,
	"./reports/limitationsReport/filterDepositReports.js": 579,
	"./reports/limitationsReport/tableDepositReports": 580,
	"./reports/limitationsReport/tableDepositReports.js": 580,
	"./reports/logsUser/filter": 583,
	"./reports/logsUser/filter.js": 583,
	"./reports/logsUser/table": 584,
	"./reports/logsUser/table.js": 584,
	"./reports/loteryReport/detailsLoteryReport": 160,
	"./reports/loteryReport/detailsLoteryReport.js": 160,
	"./reports/loteryReport/filterLoteryReport": 585,
	"./reports/loteryReport/filterLoteryReport.js": 585,
	"./reports/loteryReport/recordLoteryReport": 161,
	"./reports/loteryReport/recordLoteryReport.js": 161,
	"./reports/loteryReport/recordTableLoteryReport": 1839,
	"./reports/loteryReport/recordTableLoteryReport.js": 1839,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory": 586,
	"./reports/loyaltyLevelChangeHistory/filterLoyaltyLevelChangeHistory.js": 586,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory": 587,
	"./reports/loyaltyLevelChangeHistory/tableLoyaltyLevelChangeHistory.js": 587,
	"./reports/my_comissions_report/filter": 670,
	"./reports/my_comissions_report/filter.js": 670,
	"./reports/my_comissions_report/table": 671,
	"./reports/my_comissions_report/table.js": 671,
	"./reports/notesUser/filter": 672,
	"./reports/notesUser/filter.js": 672,
	"./reports/notesUser/table": 673,
	"./reports/notesUser/table.js": 673,
	"./reports/operatorResponsibility/filter": 674,
	"./reports/operatorResponsibility/filter.js": 674,
	"./reports/operatorResponsibility/table": 675,
	"./reports/operatorResponsibility/table.js": 675,
	"./reports/partners-categories/filter": 812,
	"./reports/partners-categories/filter.js": 812,
	"./reports/partners-categories/table": 813,
	"./reports/partners-categories/table.js": 813,
	"./reports/playersReport/detailsPlayersReport": 841,
	"./reports/playersReport/detailsPlayersReport.js": 841,
	"./reports/playersReport/filterPlayersReport": 839,
	"./reports/playersReport/filterPlayersReport.js": 839,
	"./reports/playersReport/recordPlayersReport": 842,
	"./reports/playersReport/recordPlayersReport.js": 842,
	"./reports/playersReport/recordTablePlayersReport": 843,
	"./reports/playersReport/recordTablePlayersReport.js": 843,
	"./reports/playersReport/tablePlayersReport": 840,
	"./reports/playersReport/tablePlayersReport.js": 840,
	"./reports/pointSettings/filter": 844,
	"./reports/pointSettings/filter.js": 844,
	"./reports/pointSettings/table": 845,
	"./reports/pointSettings/table.js": 845,
	"./reports/pointsUsers/filter": 846,
	"./reports/pointsUsers/filter.js": 846,
	"./reports/pointsUsers/table": 847,
	"./reports/pointsUsers/table.js": 847,
	"./reports/pokerReport/filterCasinoReport": 848,
	"./reports/pokerReport/filterCasinoReport.js": 848,
	"./reports/pokerReport/tableCasinoReport": 849,
	"./reports/pokerReport/tableCasinoReport.js": 849,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1840,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1840,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 680,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 680,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1841,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1841,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 916,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 916,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 681,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 681,
	"./reports/prizesLoyalty/filter": 850,
	"./reports/prizesLoyalty/filter.js": 850,
	"./reports/prizesLoyalty/table": 851,
	"./reports/prizesLoyalty/table.js": 851,
	"./reports/promotionalCasinoCampaings/filter": 867,
	"./reports/promotionalCasinoCampaings/filter.js": 867,
	"./reports/promotionalCasinoCampaings/table": 868,
	"./reports/promotionalCasinoCampaings/table.js": 868,
	"./reports/promotionalCodes/filter": 869,
	"./reports/promotionalCodes/filter.js": 869,
	"./reports/promotionalCodes/table": 870,
	"./reports/promotionalCodes/table.js": 870,
	"./reports/promotionalSpoortbookCampaings/filter": 871,
	"./reports/promotionalSpoortbookCampaings/filter.js": 871,
	"./reports/promotionalSpoortbookCampaings/table": 872,
	"./reports/promotionalSpoortbookCampaings/table.js": 872,
	"./reports/quotaRetraction/filter": 875,
	"./reports/quotaRetraction/filter.js": 875,
	"./reports/quotaRetraction/table": 876,
	"./reports/quotaRetraction/table.js": 876,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 877,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 877,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1842,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1842,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1843,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1843,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 878,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 878,
	"./reports/referralsReport/filterReferralsReports": 879,
	"./reports/referralsReport/filterReferralsReports.js": 879,
	"./reports/referralsReport/recordReferralsReports": 1844,
	"./reports/referralsReport/recordReferralsReports.js": 1844,
	"./reports/referralsReport/recordTableReferralsReports": 1845,
	"./reports/referralsReport/recordTableReferralsReports.js": 1845,
	"./reports/referralsReport/tableReferralsReports": 880,
	"./reports/referralsReport/tableReferralsReports.js": 880,
	"./reports/registeredDocuments/filter": 881,
	"./reports/registeredDocuments/filter.js": 881,
	"./reports/registeredDocuments/record": 163,
	"./reports/registeredDocuments/record.js": 163,
	"./reports/registeredDocuments/recordTable": 883,
	"./reports/registeredDocuments/recordTable.js": 883,
	"./reports/registeredDocuments/table": 882,
	"./reports/registeredDocuments/table.js": 882,
	"./reports/relationUserAggregator/filter": 898,
	"./reports/relationUserAggregator/filter.js": 898,
	"./reports/relationUserAggregator/table": 899,
	"./reports/relationUserAggregator/table.js": 899,
	"./reports/reportHash/filter": 900,
	"./reports/reportHash/filter.js": 900,
	"./reports/reportHash/table": 901,
	"./reports/reportHash/table.js": 901,
	"./reports/reportMarketing/filter": 902,
	"./reports/reportMarketing/filter.js": 902,
	"./reports/reportMarketing/table": 903,
	"./reports/reportMarketing/table.js": 903,
	"./reports/rouletteReport/filter": 917,
	"./reports/rouletteReport/filter.js": 917,
	"./reports/rouletteReport/table": 918,
	"./reports/rouletteReport/table.js": 918,
	"./reports/sessionsReport/detailsSessionsReport": 919,
	"./reports/sessionsReport/detailsSessionsReport.js": 919,
	"./reports/sessionsReport/filterSessionsReport": 920,
	"./reports/sessionsReport/filterSessionsReport.js": 920,
	"./reports/sessionsReport/recordSessionsReport": 1036,
	"./reports/sessionsReport/recordSessionsReport.js": 1036,
	"./reports/sessionsReport/recordTableSessionsReport": 1037,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1037,
	"./reports/sessionsReport/tableSessionsReport": 921,
	"./reports/sessionsReport/tableSessionsReport.js": 921,
	"./reports/sessionsReport2/filter": 922,
	"./reports/sessionsReport2/filter.js": 922,
	"./reports/sessionsReport2/table": 923,
	"./reports/sessionsReport2/table.js": 923,
	"./reports/sportsPoolReport/filterReport": 924,
	"./reports/sportsPoolReport/filterReport.js": 924,
	"./reports/sportsPoolReport/tableReport": 925,
	"./reports/sportsPoolReport/tableReport.js": 925,
	"./reports/sportsTransactions/filter": 926,
	"./reports/sportsTransactions/filter.js": 926,
	"./reports/sportsTransactions/table": 927,
	"./reports/sportsTransactions/table.js": 927,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 928,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 928,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 929,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 929,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 930,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 930,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1846,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1846,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 931,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 931,
	"./reports/taxPaymentsReport/filter": 932,
	"./reports/taxPaymentsReport/filter.js": 932,
	"./reports/taxPaymentsReport/table": 933,
	"./reports/taxPaymentsReport/table.js": 933,
	"./reports/taxableEarnings/filter": 934,
	"./reports/taxableEarnings/filter.js": 934,
	"./reports/taxableEarnings/table": 935,
	"./reports/taxableEarnings/table.js": 935,
	"./reports/transactionReport/filter": 936,
	"./reports/transactionReport/filter.js": 936,
	"./reports/transactionReport/table": 937,
	"./reports/transactionReport/table.js": 937,
	"./reports/transfersReport/filter": 938,
	"./reports/transfersReport/filter.js": 938,
	"./reports/transfersReport/table": 939,
	"./reports/transfersReport/table.js": 939,
	"./reports/userAffiliatesAgent/filter": 940,
	"./reports/userAffiliatesAgent/filter.js": 940,
	"./reports/userAffiliatesAgent/table": 941,
	"./reports/userAffiliatesAgent/table.js": 941,
	"./reports/userAffiliatesBetShop/filter": 942,
	"./reports/userAffiliatesBetShop/filter.js": 942,
	"./reports/userAffiliatesBetShop/table": 943,
	"./reports/userAffiliatesBetShop/table.js": 943,
	"./reports/usuarioOnlineResumido/filter": 944,
	"./reports/usuarioOnlineResumido/filter.js": 944,
	"./reports/usuarioOnlineResumido/table": 945,
	"./reports/usuarioOnlineResumido/table.js": 945,
	"./reports/withdrawalReport2/filter": 946,
	"./reports/withdrawalReport2/filter.js": 946,
	"./reports/withdrawalReport2/table": 947,
	"./reports/withdrawalReport2/table.js": 947,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 948,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 948,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 949,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 949,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1847,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1847,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 950,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 950,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 951,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 951,
	"./reports/withdrawalRequestsComissions/filter": 952,
	"./reports/withdrawalRequestsComissions/filter.js": 952,
	"./reports/withdrawalRequestsComissions/table": 953,
	"./reports/withdrawalRequestsComissions/table.js": 953,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 164,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 164,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 954,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 954,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 125,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 125,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 165,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 165,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 955,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 955,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 956,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 956,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1848,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1848,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 957,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 957,
	"./reprintCheck": 1849,
	"./reprintCheck.js": 1849,
	"./requests/registration-requests/filter": 958,
	"./requests/registration-requests/filter.js": 958,
	"./requests/registration-requests/generateRequests": 959,
	"./requests/registration-requests/generateRequests.js": 959,
	"./requests/registration-requests/recordTableResponts": 960,
	"./requests/registration-requests/recordTableResponts.js": 960,
	"./requests/registration-requests/table": 962,
	"./requests/registration-requests/table.js": 962,
	"./requests/registration-requests/tableResponts": 961,
	"./requests/registration-requests/tableResponts.js": 961,
	"./requests/registrationRequests": 1850,
	"./requests/registrationRequests.js": 1850,
	"./resources-locale_es.json": 1952,
	"./restrictUser": 1851,
	"./restrictUser.js": 1851,
	"./reversionReload": 1852,
	"./reversionReload.js": 1852,
	"./rouletteReport": 1853,
	"./rouletteReport.js": 1853,
	"./security/adminuser/addAdminUser": 1854,
	"./security/adminuser/addAdminUser.js": 1854,
	"./security/adminuser/configuration/changePassword": 1855,
	"./security/adminuser/configuration/changePassword.js": 1855,
	"./security/adminuser/configuration/changePassword/changePasswordView": 963,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 963,
	"./security/adminuser/configuration/generateToken": 1856,
	"./security/adminuser/configuration/generateToken.js": 1856,
	"./security/adminuser/configuration/generateToken/filter": 964,
	"./security/adminuser/configuration/generateToken/filter.js": 964,
	"./security/adminuser/configuration/generateToken/table": 965,
	"./security/adminuser/configuration/generateToken/table.js": 965,
	"./security/adminuser/configuration/qrgoogle": 1857,
	"./security/adminuser/configuration/qrgoogle.js": 1857,
	"./security/adminuser/configuration/securityChanges": 1858,
	"./security/adminuser/configuration/securityChanges.js": 1858,
	"./security/adminuser/configuration/securityChanges/filter": 170,
	"./security/adminuser/configuration/securityChanges/filter.js": 170,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1859,
	"./security/adminuser/configurationAdminUser.js": 1859,
	"./security/adminuser/detailsAdminUser": 1860,
	"./security/adminuser/detailsAdminUser.js": 1860,
	"./security/adminuser/filterAdminUser": 207,
	"./security/adminuser/filterAdminUser.js": 207,
	"./security/adminuser/informationAdminUser": 1861,
	"./security/adminuser/informationAdminUser.js": 1861,
	"./security/adminuser/recordAdminUser": 1862,
	"./security/adminuser/recordAdminUser.js": 1862,
	"./security/adminuser/recordTableAdminUser": 966,
	"./security/adminuser/recordTableAdminUser.js": 966,
	"./security/adminuser/reports/logsUser": 1863,
	"./security/adminuser/reports/logsUser.js": 1863,
	"./security/adminuser/reports/logsUser/filter": 967,
	"./security/adminuser/reports/logsUser/filter.js": 967,
	"./security/adminuser/reports/logsUser/table": 968,
	"./security/adminuser/reports/logsUser/table.js": 968,
	"./security/adminuser/reportsAdminUser": 1864,
	"./security/adminuser/reportsAdminUser.js": 1864,
	"./security/adminuser/tableAdminUser": 208,
	"./security/adminuser/tableAdminUser.js": 208,
	"./security/approvalLogs/filter": 286,
	"./security/approvalLogs/filter.js": 286,
	"./security/approvalLogs/table": 287,
	"./security/approvalLogs/table.js": 287,
	"./security/approvalLogs2/filter": 288,
	"./security/approvalLogs2/filter.js": 288,
	"./security/approvalLogs2/table": 289,
	"./security/approvalLogs2/table.js": 289,
	"./security/approvalLogsBetShop/filter": 290,
	"./security/approvalLogsBetShop/filter.js": 290,
	"./security/approvalLogsBetShop/table": 291,
	"./security/approvalLogsBetShop/table.js": 291,
	"./security/contingencia/detailsContingencia": 1865,
	"./security/contingencia/detailsContingencia.js": 1865,
	"./security/contingencia/filterContingencia": 438,
	"./security/contingencia/filterContingencia.js": 438,
	"./security/contingencia/recordContingencia": 1866,
	"./security/contingencia/recordContingencia.js": 1866,
	"./security/contingencia/recordTableContingencia": 969,
	"./security/contingencia/recordTableContingencia.js": 969,
	"./security/contingencia/tableContingencia": 439,
	"./security/contingencia/tableContingencia.js": 439,
	"./security/menu/filter": 660,
	"./security/menu/filter.js": 660,
	"./security/menu/table": 661,
	"./security/menu/table.js": 661,
	"./security/perfil/detailsPerfil": 864,
	"./security/perfil/detailsPerfil.js": 864,
	"./security/perfil/filterPerfil": 862,
	"./security/perfil/filterPerfil.js": 862,
	"./security/perfil/recordPerfil": 865,
	"./security/perfil/recordPerfil.js": 865,
	"./security/perfil/recordTablePerfil": 866,
	"./security/perfil/recordTablePerfil.js": 866,
	"./security/perfil/tablePerfil": 863,
	"./security/perfil/tablePerfil.js": 863,
	"./security/perfilopciones/detailsPerfilOpciones": 123,
	"./security/perfilopciones/detailsPerfilOpciones.js": 123,
	"./security/perfilopciones/filterPerfilOpciones": 85,
	"./security/perfilopciones/filterPerfilOpciones.js": 85,
	"./security/perfilopciones/recordPerfilOpciones": 124,
	"./security/perfilopciones/recordPerfilOpciones.js": 124,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1867,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1867,
	"./security/perfilopciones2/filterPerfilOpciones": 1868,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1868,
	"./security/perfilopciones2/recordPerfilOpciones": 1869,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1869,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1870,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1870,
	"./security/perfilopciones2/tablePerfilOpciones": 1871,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1871,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1872,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1872,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1873,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1873,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1874,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1874,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1875,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1875,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1876,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1876,
	"./security/submenu/detailsSubMenu": 970,
	"./security/submenu/detailsSubMenu.js": 970,
	"./security/submenu/filterSubMenu": 971,
	"./security/submenu/filterSubMenu.js": 971,
	"./security/submenu/recordSubMenu": 972,
	"./security/submenu/recordSubMenu.js": 972,
	"./security/submenu/recordTableSubMenu": 973,
	"./security/submenu/recordTableSubMenu.js": 973,
	"./security/submenu/tableSubMenu": 974,
	"./security/submenu/tableSubMenu.js": 974,
	"./security/totalContingencies/table": 975,
	"./security/totalContingencies/table.js": 975,
	"./security/userSitebuilder/filter": 976,
	"./security/userSitebuilder/filter.js": 976,
	"./security/userSitebuilder/information": 1877,
	"./security/userSitebuilder/information.js": 1877,
	"./security/userSitebuilder/table": 977,
	"./security/userSitebuilder/table.js": 977,
	"./security/userVerification2/filter": 978,
	"./security/userVerification2/filter.js": 978,
	"./security/userVerification2/information": 1878,
	"./security/userVerification2/information.js": 1878,
	"./security/userVerification2/table": 979,
	"./security/userVerification2/table.js": 979,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1879,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1879,
	"./security/usuarioperfil/filterUsuarioPerfil": 980,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 980,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 981,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 981,
	"./security/usuarioperfil/recordUsuarioPerfil": 1880,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1880,
	"./security/usuarioperfil/tableUsuarioPerfil": 982,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 982,
	"./security/usuariosbloqueados/add": 1881,
	"./security/usuariosbloqueados/add.js": 1881,
	"./security/usuariosbloqueados/filter": 983,
	"./security/usuariosbloqueados/filter.js": 983,
	"./security/usuariosbloqueados/table": 984,
	"./security/usuariosbloqueados/table.js": 984,
	"./security/wallets/filter": 985,
	"./security/wallets/filter.js": 985,
	"./security/wallets/table": 986,
	"./security/wallets/table.js": 986,
	"./sessionsReport": 1882,
	"./sessionsReport.js": 1882,
	"./sessionsReport2": 1883,
	"./sessionsReport2.js": 1883,
	"./settings": 1884,
	"./settings.js": 1884,
	"./significantEventsAndAlterations": 1885,
	"./significantEventsAndAlterations.js": 1885,
	"./significantEventsAndAlterations2": 1886,
	"./significantEventsAndAlterations2.js": 1886,
	"./sportsPoolReport": 1887,
	"./sportsPoolReport.js": 1887,
	"./sportsTransactions": 1888,
	"./sportsTransactions.js": 1888,
	"./subMenu": 1889,
	"./subMenu.js": 1889,
	"./subProviders": 1890,
	"./subProviders.js": 1890,
	"./summaryBetsReport": 1891,
	"./summaryBetsReport.js": 1891,
	"./summaryCashFlow": 1892,
	"./summaryCashFlow.js": 1892,
	"./summaryCashFlow2": 1893,
	"./summaryCashFlow2.js": 1893,
	"./summaryCashFlowMachine": 1894,
	"./summaryCashFlowMachine.js": 1894,
	"./tags": 1895,
	"./tags.js": 1895,
	"./taxPaymentsReport": 1896,
	"./taxPaymentsReport.js": 1896,
	"./taxableEarnings": 1897,
	"./taxableEarnings.js": 1897,
	"./teacher/concessionaire/filterConcessionaire": 512,
	"./teacher/concessionaire/filterConcessionaire.js": 512,
	"./teacher/concessionaire/tableConcessionaire": 513,
	"./teacher/concessionaire/tableConcessionaire.js": 513,
	"./teacher/qualifying/filterQualifying": 873,
	"./teacher/qualifying/filterQualifying.js": 873,
	"./teacher/qualifying/tableQualifying": 874,
	"./teacher/qualifying/tableQualifying.js": 874,
	"./teacher/registered-documents/filterRegisteredDocuments": 884,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 884,
	"./teacher/registered-documents/tableRegisteredDocuments": 885,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 885,
	"./termsAndConditions": 1898,
	"./termsAndConditions.js": 1898,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 440,
	"./tools/countries/filter.js": 440,
	"./tools/countries/table": 441,
	"./tools/countries/table.js": 441,
	"./tools/currencyManagement/currencyFilters": 171,
	"./tools/currencyManagement/currencyFilters.js": 171,
	"./tools/currencyManagement/currencyTable": 172,
	"./tools/currencyManagement/currencyTable.js": 172,
	"./tools/translationManager": 1899,
	"./tools/translationManager.js": 1899,
	"./tools/translationManager/filter": 987,
	"./tools/translationManager/filter.js": 987,
	"./tools/translationManager/table": 988,
	"./tools/translationManager/table.js": 988,
	"./tools/uploadImage": 1900,
	"./tools/uploadImage.js": 1900,
	"./top": 1901,
	"./top.js": 1901,
	"./totalContingencies": 1902,
	"./totalContingencies.js": 1902,
	"./transactionReport": 1903,
	"./transactionReport.js": 1903,
	"./transactions": 1904,
	"./transactions.js": 1904,
	"./transactionsByPlayer": 1905,
	"./transactionsByPlayer.js": 1905,
	"./transactionsByPlayerDeposit": 1906,
	"./transactionsByPlayerDeposit.js": 1906,
	"./transactionsByPlayerFirstLevel": 1907,
	"./transactionsByPlayerFirstLevel.js": 1907,
	"./transactionsByPlayerSecondLevel": 1908,
	"./transactionsByPlayerSecondLevel.js": 1908,
	"./trasnfersReport": 1909,
	"./trasnfersReport.js": 1909,
	"./tutorials": 1910,
	"./tutorials.js": 1910,
	"./userAffiliatesAgent": 1911,
	"./userAffiliatesAgent.js": 1911,
	"./userAffiliatesBetShop": 1912,
	"./userAffiliatesBetShop.js": 1912,
	"./userManagement": 1913,
	"./userManagement.js": 1913,
	"./userManagement/userManagement/detailsUserManagement": 991,
	"./userManagement/userManagement/detailsUserManagement.js": 991,
	"./userManagement/userManagement/filterUserManagement": 989,
	"./userManagement/userManagement/filterUserManagement.js": 989,
	"./userManagement/userManagement/recordTableUserManagement": 993,
	"./userManagement/userManagement/recordTableUserManagement.js": 993,
	"./userManagement/userManagement/recordUserManagement": 992,
	"./userManagement/userManagement/recordUserManagement.js": 992,
	"./userManagement/userManagement/tableUserManagement": 990,
	"./userManagement/userManagement/tableUserManagement.js": 990,
	"./userProfile": 1914,
	"./userProfile.js": 1914,
	"./usersSitebuilder": 1915,
	"./usersSitebuilder.js": 1915,
	"./usersVerification": 1916,
	"./usersVerification.js": 1916,
	"./usersVerification/information": 994,
	"./usersVerification/information.js": 994,
	"./usersVerification2": 1917,
	"./usersVerification2.js": 1917,
	"./usersVerificationManagement": 1918,
	"./usersVerificationManagement.js": 1918,
	"./usuarioOnlineResumido": 1919,
	"./usuarioOnlineResumido.js": 1919,
	"./usuariosbloqueados": 1920,
	"./usuariosbloqueados.js": 1920,
	"./verifyAccount": 1921,
	"./verifyAccount.js": 1921,
	"./verifyAccountAgent": 1922,
	"./verifyAccountAgent.js": 1922,
	"./verifyAccountJumio": 1923,
	"./verifyAccountJumio.js": 1923,
	"./wallets": 1924,
	"./wallets.js": 1924,
	"./watchListReport": 1925,
	"./watchListReport.js": 1925,
	"./watchListReport/filterReport": 995,
	"./watchListReport/filterReport.js": 995,
	"./watchListReport/tableReport": 996,
	"./watchListReport/tableReport.js": 996,
	"./widgets": 1926,
	"./widgets.js": 1926,
	"./withdrawal": 1927,
	"./withdrawal.js": 1927,
	"./withdrawalReport2": 1928,
	"./withdrawalReport2.js": 1928,
	"./withdrawalRequests": 1929,
	"./withdrawalRequests.js": 1929,
	"./withdrawalRequestsBetShop": 1930,
	"./withdrawalRequestsBetShop.js": 1930,
	"./withdrawalRequestsComissions": 1931,
	"./withdrawalRequestsComissions.js": 1931,
	"./withdrawalRequestsForBetShop": 1932,
	"./withdrawalRequestsForBetShop.js": 1932,
	"./withdrawalRequestsForBetShop2": 1933,
	"./withdrawalRequestsForBetShop2.js": 1933,
	"./withdrawalRequestsRetail": 1934,
	"./withdrawalRequestsRetail.js": 1934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1944;